/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Room = (function() {

    /**
     * Namespace Room.
     * @exports Room
     * @namespace
     */
    var Room = {};

    Room.PosInfo = (function() {

        /**
         * Properties of a PosInfo.
         * @memberof Room
         * @interface IPosInfo
         * @property {number|null} [posIndex] PosInfo posIndex
         * @property {number|null} [playerId] PosInfo playerId
         * @property {number|null} [isReady] PosInfo isReady
         * @property {number|null} [coinBalance] PosInfo coinBalance
         */

        /**
         * Constructs a new PosInfo.
         * @memberof Room
         * @classdesc Represents a PosInfo.
         * @implements IPosInfo
         * @constructor
         * @param {Room.IPosInfo=} [properties] Properties to set
         */
        function PosInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * PosInfo posIndex.
         * @member {number} posIndex
         * @memberof Room.PosInfo
         * @instance
         */
        PosInfo.prototype.posIndex = 0;

        /**
         * PosInfo playerId.
         * @member {number} playerId
         * @memberof Room.PosInfo
         * @instance
         */
        PosInfo.prototype.playerId = 0;

        /**
         * PosInfo isReady.
         * @member {number} isReady
         * @memberof Room.PosInfo
         * @instance
         */
        PosInfo.prototype.isReady = 0;

        /**
         * PosInfo coinBalance.
         * @member {number} coinBalance
         * @memberof Room.PosInfo
         * @instance
         */
        PosInfo.prototype.coinBalance = 0;

        /**
         * Creates a new PosInfo instance using the specified properties.
         * @function create
         * @memberof Room.PosInfo
         * @static
         * @param {Room.IPosInfo=} [properties] Properties to set
         * @returns {Room.PosInfo} PosInfo instance
         */
        PosInfo.create = function create(properties) {
            return new PosInfo(properties);
        };

        /**
         * Encodes the specified PosInfo message. Does not implicitly {@link Room.PosInfo.verify|verify} messages.
         * @function encode
         * @memberof Room.PosInfo
         * @static
         * @param {Room.IPosInfo} message PosInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PosInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.posIndex != null && message.hasOwnProperty("posIndex"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.posIndex);
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.playerId);
            if (message.isReady != null && message.hasOwnProperty("isReady"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.isReady);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.coinBalance);
            return writer;
        };

        /**
         * Encodes the specified PosInfo message, length delimited. Does not implicitly {@link Room.PosInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.PosInfo
         * @static
         * @param {Room.IPosInfo} message PosInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PosInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PosInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Room.PosInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.PosInfo} PosInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PosInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.PosInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.posIndex = reader.int32();
                    break;
                case 2:
                    message.playerId = reader.int32();
                    break;
                case 3:
                    message.isReady = reader.int32();
                    break;
                case 4:
                    message.coinBalance = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a PosInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.PosInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.PosInfo} PosInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PosInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a PosInfo message.
         * @function verify
         * @memberof Room.PosInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        PosInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.posIndex != null && message.hasOwnProperty("posIndex"))
                if (!$util.isInteger(message.posIndex))
                    return "posIndex: integer expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.isReady != null && message.hasOwnProperty("isReady"))
                if (!$util.isInteger(message.isReady))
                    return "isReady: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (!$util.isInteger(message.coinBalance))
                    return "coinBalance: integer expected";
            return null;
        };

        /**
         * Creates a PosInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.PosInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.PosInfo} PosInfo
         */
        PosInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.PosInfo)
                return object;
            var message = new $root.Room.PosInfo();
            if (object.posIndex != null)
                message.posIndex = object.posIndex | 0;
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.isReady != null)
                message.isReady = object.isReady | 0;
            if (object.coinBalance != null)
                message.coinBalance = object.coinBalance | 0;
            return message;
        };

        /**
         * Creates a plain object from a PosInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.PosInfo
         * @static
         * @param {Room.PosInfo} message PosInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        PosInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.posIndex = 0;
                object.playerId = 0;
                object.isReady = 0;
                object.coinBalance = 0;
            }
            if (message.posIndex != null && message.hasOwnProperty("posIndex"))
                object.posIndex = message.posIndex;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.isReady != null && message.hasOwnProperty("isReady"))
                object.isReady = message.isReady;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = message.coinBalance;
            return object;
        };

        /**
         * Converts this PosInfo to JSON.
         * @function toJSON
         * @memberof Room.PosInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        PosInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return PosInfo;
    })();

    Room.ExpiresInfo = (function() {

        /**
         * Properties of an ExpiresInfo.
         * @memberof Room
         * @interface IExpiresInfo
         * @property {number|null} [state] ExpiresInfo state
         * @property {number|null} [expire] ExpiresInfo expire
         */

        /**
         * Constructs a new ExpiresInfo.
         * @memberof Room
         * @classdesc Represents an ExpiresInfo.
         * @implements IExpiresInfo
         * @constructor
         * @param {Room.IExpiresInfo=} [properties] Properties to set
         */
        function ExpiresInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ExpiresInfo state.
         * @member {number} state
         * @memberof Room.ExpiresInfo
         * @instance
         */
        ExpiresInfo.prototype.state = 0;

        /**
         * ExpiresInfo expire.
         * @member {number} expire
         * @memberof Room.ExpiresInfo
         * @instance
         */
        ExpiresInfo.prototype.expire = 0;

        /**
         * Creates a new ExpiresInfo instance using the specified properties.
         * @function create
         * @memberof Room.ExpiresInfo
         * @static
         * @param {Room.IExpiresInfo=} [properties] Properties to set
         * @returns {Room.ExpiresInfo} ExpiresInfo instance
         */
        ExpiresInfo.create = function create(properties) {
            return new ExpiresInfo(properties);
        };

        /**
         * Encodes the specified ExpiresInfo message. Does not implicitly {@link Room.ExpiresInfo.verify|verify} messages.
         * @function encode
         * @memberof Room.ExpiresInfo
         * @static
         * @param {Room.IExpiresInfo} message ExpiresInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpiresInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.state);
            if (message.expire != null && message.hasOwnProperty("expire"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.expire);
            return writer;
        };

        /**
         * Encodes the specified ExpiresInfo message, length delimited. Does not implicitly {@link Room.ExpiresInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ExpiresInfo
         * @static
         * @param {Room.IExpiresInfo} message ExpiresInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ExpiresInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an ExpiresInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ExpiresInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ExpiresInfo} ExpiresInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpiresInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ExpiresInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.state = reader.int32();
                    break;
                case 2:
                    message.expire = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an ExpiresInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ExpiresInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ExpiresInfo} ExpiresInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ExpiresInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an ExpiresInfo message.
         * @function verify
         * @memberof Room.ExpiresInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ExpiresInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.expire != null && message.hasOwnProperty("expire"))
                if (!$util.isInteger(message.expire))
                    return "expire: integer expected";
            return null;
        };

        /**
         * Creates an ExpiresInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ExpiresInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ExpiresInfo} ExpiresInfo
         */
        ExpiresInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ExpiresInfo)
                return object;
            var message = new $root.Room.ExpiresInfo();
            if (object.state != null)
                message.state = object.state | 0;
            if (object.expire != null)
                message.expire = object.expire | 0;
            return message;
        };

        /**
         * Creates a plain object from an ExpiresInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ExpiresInfo
         * @static
         * @param {Room.ExpiresInfo} message ExpiresInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ExpiresInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.state = 0;
                object.expire = 0;
            }
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.expire != null && message.hasOwnProperty("expire"))
                object.expire = message.expire;
            return object;
        };

        /**
         * Converts this ExpiresInfo to JSON.
         * @function toJSON
         * @memberof Room.ExpiresInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ExpiresInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ExpiresInfo;
    })();

    Room.RoomInfo = (function() {

        /**
         * Properties of a RoomInfo.
         * @memberof Room
         * @interface IRoomInfo
         * @property {string|null} [roomNum] RoomInfo roomNum
         * @property {number|null} [ruleType] RoomInfo ruleType
         * @property {number|null} [totalRoundCount] RoomInfo totalRoundCount
         * @property {number|null} [curRoundNum] RoomInfo curRoundNum
         * @property {number|null} [state] RoomInfo state
         * @property {number|null} [serverNow] RoomInfo serverNow
         */

        /**
         * Constructs a new RoomInfo.
         * @memberof Room
         * @classdesc Represents a RoomInfo.
         * @implements IRoomInfo
         * @constructor
         * @param {Room.IRoomInfo=} [properties] Properties to set
         */
        function RoomInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomInfo roomNum.
         * @member {string} roomNum
         * @memberof Room.RoomInfo
         * @instance
         */
        RoomInfo.prototype.roomNum = "";

        /**
         * RoomInfo ruleType.
         * @member {number} ruleType
         * @memberof Room.RoomInfo
         * @instance
         */
        RoomInfo.prototype.ruleType = 0;

        /**
         * RoomInfo totalRoundCount.
         * @member {number} totalRoundCount
         * @memberof Room.RoomInfo
         * @instance
         */
        RoomInfo.prototype.totalRoundCount = 0;

        /**
         * RoomInfo curRoundNum.
         * @member {number} curRoundNum
         * @memberof Room.RoomInfo
         * @instance
         */
        RoomInfo.prototype.curRoundNum = 0;

        /**
         * RoomInfo state.
         * @member {number} state
         * @memberof Room.RoomInfo
         * @instance
         */
        RoomInfo.prototype.state = 0;

        /**
         * RoomInfo serverNow.
         * @member {number} serverNow
         * @memberof Room.RoomInfo
         * @instance
         */
        RoomInfo.prototype.serverNow = 0;

        /**
         * Creates a new RoomInfo instance using the specified properties.
         * @function create
         * @memberof Room.RoomInfo
         * @static
         * @param {Room.IRoomInfo=} [properties] Properties to set
         * @returns {Room.RoomInfo} RoomInfo instance
         */
        RoomInfo.create = function create(properties) {
            return new RoomInfo(properties);
        };

        /**
         * Encodes the specified RoomInfo message. Does not implicitly {@link Room.RoomInfo.verify|verify} messages.
         * @function encode
         * @memberof Room.RoomInfo
         * @static
         * @param {Room.IRoomInfo} message RoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomNum != null && message.hasOwnProperty("roomNum"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.roomNum);
            if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.ruleType);
            if (message.totalRoundCount != null && message.hasOwnProperty("totalRoundCount"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.totalRoundCount);
            if (message.curRoundNum != null && message.hasOwnProperty("curRoundNum"))
                writer.uint32(/* id 4, wireType 0 =*/32).int32(message.curRoundNum);
            if (message.state != null && message.hasOwnProperty("state"))
                writer.uint32(/* id 5, wireType 0 =*/40).int32(message.state);
            if (message.serverNow != null && message.hasOwnProperty("serverNow"))
                writer.uint32(/* id 6, wireType 0 =*/48).int32(message.serverNow);
            return writer;
        };

        /**
         * Encodes the specified RoomInfo message, length delimited. Does not implicitly {@link Room.RoomInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.RoomInfo
         * @static
         * @param {Room.IRoomInfo} message RoomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Room.RoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.RoomInfo} RoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.RoomInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomNum = reader.string();
                    break;
                case 2:
                    message.ruleType = reader.int32();
                    break;
                case 3:
                    message.totalRoundCount = reader.int32();
                    break;
                case 4:
                    message.curRoundNum = reader.int32();
                    break;
                case 5:
                    message.state = reader.int32();
                    break;
                case 6:
                    message.serverNow = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.RoomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.RoomInfo} RoomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomInfo message.
         * @function verify
         * @memberof Room.RoomInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomNum != null && message.hasOwnProperty("roomNum"))
                if (!$util.isString(message.roomNum))
                    return "roomNum: string expected";
            if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                if (!$util.isInteger(message.ruleType))
                    return "ruleType: integer expected";
            if (message.totalRoundCount != null && message.hasOwnProperty("totalRoundCount"))
                if (!$util.isInteger(message.totalRoundCount))
                    return "totalRoundCount: integer expected";
            if (message.curRoundNum != null && message.hasOwnProperty("curRoundNum"))
                if (!$util.isInteger(message.curRoundNum))
                    return "curRoundNum: integer expected";
            if (message.state != null && message.hasOwnProperty("state"))
                if (!$util.isInteger(message.state))
                    return "state: integer expected";
            if (message.serverNow != null && message.hasOwnProperty("serverNow"))
                if (!$util.isInteger(message.serverNow))
                    return "serverNow: integer expected";
            return null;
        };

        /**
         * Creates a RoomInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.RoomInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.RoomInfo} RoomInfo
         */
        RoomInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.RoomInfo)
                return object;
            var message = new $root.Room.RoomInfo();
            if (object.roomNum != null)
                message.roomNum = String(object.roomNum);
            if (object.ruleType != null)
                message.ruleType = object.ruleType | 0;
            if (object.totalRoundCount != null)
                message.totalRoundCount = object.totalRoundCount | 0;
            if (object.curRoundNum != null)
                message.curRoundNum = object.curRoundNum | 0;
            if (object.state != null)
                message.state = object.state | 0;
            if (object.serverNow != null)
                message.serverNow = object.serverNow | 0;
            return message;
        };

        /**
         * Creates a plain object from a RoomInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.RoomInfo
         * @static
         * @param {Room.RoomInfo} message RoomInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomNum = "";
                object.ruleType = 0;
                object.totalRoundCount = 0;
                object.curRoundNum = 0;
                object.state = 0;
                object.serverNow = 0;
            }
            if (message.roomNum != null && message.hasOwnProperty("roomNum"))
                object.roomNum = message.roomNum;
            if (message.ruleType != null && message.hasOwnProperty("ruleType"))
                object.ruleType = message.ruleType;
            if (message.totalRoundCount != null && message.hasOwnProperty("totalRoundCount"))
                object.totalRoundCount = message.totalRoundCount;
            if (message.curRoundNum != null && message.hasOwnProperty("curRoundNum"))
                object.curRoundNum = message.curRoundNum;
            if (message.state != null && message.hasOwnProperty("state"))
                object.state = message.state;
            if (message.serverNow != null && message.hasOwnProperty("serverNow"))
                object.serverNow = message.serverNow;
            return object;
        };

        /**
         * Converts this RoomInfo to JSON.
         * @function toJSON
         * @memberof Room.RoomInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomInfo;
    })();

    Room.ChatMsg = (function() {

        /**
         * Properties of a ChatMsg.
         * @memberof Room
         * @interface IChatMsg
         * @property {number|null} [msgType] ChatMsg msgType
         * @property {string|null} [text] ChatMsg text
         */

        /**
         * Constructs a new ChatMsg.
         * @memberof Room
         * @classdesc Represents a ChatMsg.
         * @implements IChatMsg
         * @constructor
         * @param {Room.IChatMsg=} [properties] Properties to set
         */
        function ChatMsg(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatMsg msgType.
         * @member {number} msgType
         * @memberof Room.ChatMsg
         * @instance
         */
        ChatMsg.prototype.msgType = 0;

        /**
         * ChatMsg text.
         * @member {string} text
         * @memberof Room.ChatMsg
         * @instance
         */
        ChatMsg.prototype.text = "";

        /**
         * Creates a new ChatMsg instance using the specified properties.
         * @function create
         * @memberof Room.ChatMsg
         * @static
         * @param {Room.IChatMsg=} [properties] Properties to set
         * @returns {Room.ChatMsg} ChatMsg instance
         */
        ChatMsg.create = function create(properties) {
            return new ChatMsg(properties);
        };

        /**
         * Encodes the specified ChatMsg message. Does not implicitly {@link Room.ChatMsg.verify|verify} messages.
         * @function encode
         * @memberof Room.ChatMsg
         * @static
         * @param {Room.IChatMsg} message ChatMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsg.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.msgType);
            if (message.text != null && message.hasOwnProperty("text"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.text);
            return writer;
        };

        /**
         * Encodes the specified ChatMsg message, length delimited. Does not implicitly {@link Room.ChatMsg.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ChatMsg
         * @static
         * @param {Room.IChatMsg} message ChatMsg message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsg.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatMsg message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ChatMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ChatMsg} ChatMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsg.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ChatMsg();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.msgType = reader.int32();
                    break;
                case 2:
                    message.text = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatMsg message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ChatMsg
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ChatMsg} ChatMsg
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsg.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatMsg message.
         * @function verify
         * @memberof Room.ChatMsg
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatMsg.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                if (!$util.isInteger(message.msgType))
                    return "msgType: integer expected";
            if (message.text != null && message.hasOwnProperty("text"))
                if (!$util.isString(message.text))
                    return "text: string expected";
            return null;
        };

        /**
         * Creates a ChatMsg message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ChatMsg
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ChatMsg} ChatMsg
         */
        ChatMsg.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ChatMsg)
                return object;
            var message = new $root.Room.ChatMsg();
            if (object.msgType != null)
                message.msgType = object.msgType | 0;
            if (object.text != null)
                message.text = String(object.text);
            return message;
        };

        /**
         * Creates a plain object from a ChatMsg message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ChatMsg
         * @static
         * @param {Room.ChatMsg} message ChatMsg
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatMsg.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.msgType = 0;
                object.text = "";
            }
            if (message.msgType != null && message.hasOwnProperty("msgType"))
                object.msgType = message.msgType;
            if (message.text != null && message.hasOwnProperty("text"))
                object.text = message.text;
            return object;
        };

        /**
         * Converts this ChatMsg to JSON.
         * @function toJSON
         * @memberof Room.ChatMsg
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatMsg.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChatMsg;
    })();

    Room.ChatHistory = (function() {

        /**
         * Properties of a ChatHistory.
         * @memberof Room
         * @interface IChatHistory
         * @property {Array.<Room.ChatHistory.IChatRecord>|null} [history] ChatHistory history
         */

        /**
         * Constructs a new ChatHistory.
         * @memberof Room
         * @classdesc Represents a ChatHistory.
         * @implements IChatHistory
         * @constructor
         * @param {Room.IChatHistory=} [properties] Properties to set
         */
        function ChatHistory(properties) {
            this.history = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatHistory history.
         * @member {Array.<Room.ChatHistory.IChatRecord>} history
         * @memberof Room.ChatHistory
         * @instance
         */
        ChatHistory.prototype.history = $util.emptyArray;

        /**
         * Creates a new ChatHistory instance using the specified properties.
         * @function create
         * @memberof Room.ChatHistory
         * @static
         * @param {Room.IChatHistory=} [properties] Properties to set
         * @returns {Room.ChatHistory} ChatHistory instance
         */
        ChatHistory.create = function create(properties) {
            return new ChatHistory(properties);
        };

        /**
         * Encodes the specified ChatHistory message. Does not implicitly {@link Room.ChatHistory.verify|verify} messages.
         * @function encode
         * @memberof Room.ChatHistory
         * @static
         * @param {Room.IChatHistory} message ChatHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatHistory.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.history != null && message.history.length)
                for (var i = 0; i < message.history.length; ++i)
                    $root.Room.ChatHistory.ChatRecord.encode(message.history[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ChatHistory message, length delimited. Does not implicitly {@link Room.ChatHistory.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ChatHistory
         * @static
         * @param {Room.IChatHistory} message ChatHistory message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatHistory.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatHistory message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ChatHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ChatHistory} ChatHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatHistory.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ChatHistory();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.history && message.history.length))
                        message.history = [];
                    message.history.push($root.Room.ChatHistory.ChatRecord.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatHistory message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ChatHistory
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ChatHistory} ChatHistory
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatHistory.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatHistory message.
         * @function verify
         * @memberof Room.ChatHistory
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatHistory.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.history != null && message.hasOwnProperty("history")) {
                if (!Array.isArray(message.history))
                    return "history: array expected";
                for (var i = 0; i < message.history.length; ++i) {
                    var error = $root.Room.ChatHistory.ChatRecord.verify(message.history[i]);
                    if (error)
                        return "history." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ChatHistory message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ChatHistory
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ChatHistory} ChatHistory
         */
        ChatHistory.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ChatHistory)
                return object;
            var message = new $root.Room.ChatHistory();
            if (object.history) {
                if (!Array.isArray(object.history))
                    throw TypeError(".Room.ChatHistory.history: array expected");
                message.history = [];
                for (var i = 0; i < object.history.length; ++i) {
                    if (typeof object.history[i] !== "object")
                        throw TypeError(".Room.ChatHistory.history: object expected");
                    message.history[i] = $root.Room.ChatHistory.ChatRecord.fromObject(object.history[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ChatHistory message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ChatHistory
         * @static
         * @param {Room.ChatHistory} message ChatHistory
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatHistory.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.history = [];
            if (message.history && message.history.length) {
                object.history = [];
                for (var j = 0; j < message.history.length; ++j)
                    object.history[j] = $root.Room.ChatHistory.ChatRecord.toObject(message.history[j], options);
            }
            return object;
        };

        /**
         * Converts this ChatHistory to JSON.
         * @function toJSON
         * @memberof Room.ChatHistory
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatHistory.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        ChatHistory.ChatRecord = (function() {

            /**
             * Properties of a ChatRecord.
             * @memberof Room.ChatHistory
             * @interface IChatRecord
             * @property {number} playerId ChatRecord playerId
             * @property {Room.IChatMsg} chatMsg ChatRecord chatMsg
             */

            /**
             * Constructs a new ChatRecord.
             * @memberof Room.ChatHistory
             * @classdesc Represents a ChatRecord.
             * @implements IChatRecord
             * @constructor
             * @param {Room.ChatHistory.IChatRecord=} [properties] Properties to set
             */
            function ChatRecord(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * ChatRecord playerId.
             * @member {number} playerId
             * @memberof Room.ChatHistory.ChatRecord
             * @instance
             */
            ChatRecord.prototype.playerId = 0;

            /**
             * ChatRecord chatMsg.
             * @member {Room.IChatMsg} chatMsg
             * @memberof Room.ChatHistory.ChatRecord
             * @instance
             */
            ChatRecord.prototype.chatMsg = null;

            /**
             * Creates a new ChatRecord instance using the specified properties.
             * @function create
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {Room.ChatHistory.IChatRecord=} [properties] Properties to set
             * @returns {Room.ChatHistory.ChatRecord} ChatRecord instance
             */
            ChatRecord.create = function create(properties) {
                return new ChatRecord(properties);
            };

            /**
             * Encodes the specified ChatRecord message. Does not implicitly {@link Room.ChatHistory.ChatRecord.verify|verify} messages.
             * @function encode
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {Room.ChatHistory.IChatRecord} message ChatRecord message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ChatRecord.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
                $root.Room.ChatMsg.encode(message.chatMsg, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
                return writer;
            };

            /**
             * Encodes the specified ChatRecord message, length delimited. Does not implicitly {@link Room.ChatHistory.ChatRecord.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {Room.ChatHistory.IChatRecord} message ChatRecord message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            ChatRecord.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a ChatRecord message from the specified reader or buffer.
             * @function decode
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Room.ChatHistory.ChatRecord} ChatRecord
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ChatRecord.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ChatHistory.ChatRecord();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.playerId = reader.int32();
                        break;
                    case 2:
                        message.chatMsg = $root.Room.ChatMsg.decode(reader, reader.uint32());
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                if (!message.hasOwnProperty("playerId"))
                    throw $util.ProtocolError("missing required 'playerId'", { instance: message });
                if (!message.hasOwnProperty("chatMsg"))
                    throw $util.ProtocolError("missing required 'chatMsg'", { instance: message });
                return message;
            };

            /**
             * Decodes a ChatRecord message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Room.ChatHistory.ChatRecord} ChatRecord
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            ChatRecord.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a ChatRecord message.
             * @function verify
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            ChatRecord.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
                {
                    var error = $root.Room.ChatMsg.verify(message.chatMsg);
                    if (error)
                        return "chatMsg." + error;
                }
                return null;
            };

            /**
             * Creates a ChatRecord message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Room.ChatHistory.ChatRecord} ChatRecord
             */
            ChatRecord.fromObject = function fromObject(object) {
                if (object instanceof $root.Room.ChatHistory.ChatRecord)
                    return object;
                var message = new $root.Room.ChatHistory.ChatRecord();
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.chatMsg != null) {
                    if (typeof object.chatMsg !== "object")
                        throw TypeError(".Room.ChatHistory.ChatRecord.chatMsg: object expected");
                    message.chatMsg = $root.Room.ChatMsg.fromObject(object.chatMsg);
                }
                return message;
            };

            /**
             * Creates a plain object from a ChatRecord message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Room.ChatHistory.ChatRecord
             * @static
             * @param {Room.ChatHistory.ChatRecord} message ChatRecord
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            ChatRecord.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.playerId = 0;
                    object.chatMsg = null;
                }
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.chatMsg != null && message.hasOwnProperty("chatMsg"))
                    object.chatMsg = $root.Room.ChatMsg.toObject(message.chatMsg, options);
                return object;
            };

            /**
             * Converts this ChatRecord to JSON.
             * @function toJSON
             * @memberof Room.ChatHistory.ChatRecord
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            ChatRecord.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return ChatRecord;
        })();

        return ChatHistory;
    })();

    Room.FreeRoomState = (function() {

        /**
         * Properties of a FreeRoomState.
         * @memberof Room
         * @interface IFreeRoomState
         * @property {number|null} [playerId] FreeRoomState playerId
         * @property {number|null} [sponsor] FreeRoomState sponsor
         * @property {boolean|null} [agree] FreeRoomState agree
         */

        /**
         * Constructs a new FreeRoomState.
         * @memberof Room
         * @classdesc Represents a FreeRoomState.
         * @implements IFreeRoomState
         * @constructor
         * @param {Room.IFreeRoomState=} [properties] Properties to set
         */
        function FreeRoomState(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FreeRoomState playerId.
         * @member {number} playerId
         * @memberof Room.FreeRoomState
         * @instance
         */
        FreeRoomState.prototype.playerId = 0;

        /**
         * FreeRoomState sponsor.
         * @member {number} sponsor
         * @memberof Room.FreeRoomState
         * @instance
         */
        FreeRoomState.prototype.sponsor = 0;

        /**
         * FreeRoomState agree.
         * @member {boolean} agree
         * @memberof Room.FreeRoomState
         * @instance
         */
        FreeRoomState.prototype.agree = false;

        /**
         * Creates a new FreeRoomState instance using the specified properties.
         * @function create
         * @memberof Room.FreeRoomState
         * @static
         * @param {Room.IFreeRoomState=} [properties] Properties to set
         * @returns {Room.FreeRoomState} FreeRoomState instance
         */
        FreeRoomState.create = function create(properties) {
            return new FreeRoomState(properties);
        };

        /**
         * Encodes the specified FreeRoomState message. Does not implicitly {@link Room.FreeRoomState.verify|verify} messages.
         * @function encode
         * @memberof Room.FreeRoomState
         * @static
         * @param {Room.IFreeRoomState} message FreeRoomState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeRoomState.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.sponsor != null && message.hasOwnProperty("sponsor"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.sponsor);
            if (message.agree != null && message.hasOwnProperty("agree"))
                writer.uint32(/* id 3, wireType 0 =*/24).bool(message.agree);
            return writer;
        };

        /**
         * Encodes the specified FreeRoomState message, length delimited. Does not implicitly {@link Room.FreeRoomState.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.FreeRoomState
         * @static
         * @param {Room.IFreeRoomState} message FreeRoomState message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeRoomState.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FreeRoomState message from the specified reader or buffer.
         * @function decode
         * @memberof Room.FreeRoomState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.FreeRoomState} FreeRoomState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeRoomState.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.FreeRoomState();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.sponsor = reader.int32();
                    break;
                case 3:
                    message.agree = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FreeRoomState message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.FreeRoomState
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.FreeRoomState} FreeRoomState
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeRoomState.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FreeRoomState message.
         * @function verify
         * @memberof Room.FreeRoomState
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FreeRoomState.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.sponsor != null && message.hasOwnProperty("sponsor"))
                if (!$util.isInteger(message.sponsor))
                    return "sponsor: integer expected";
            if (message.agree != null && message.hasOwnProperty("agree"))
                if (typeof message.agree !== "boolean")
                    return "agree: boolean expected";
            return null;
        };

        /**
         * Creates a FreeRoomState message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.FreeRoomState
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.FreeRoomState} FreeRoomState
         */
        FreeRoomState.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.FreeRoomState)
                return object;
            var message = new $root.Room.FreeRoomState();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.sponsor != null)
                message.sponsor = object.sponsor | 0;
            if (object.agree != null)
                message.agree = Boolean(object.agree);
            return message;
        };

        /**
         * Creates a plain object from a FreeRoomState message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.FreeRoomState
         * @static
         * @param {Room.FreeRoomState} message FreeRoomState
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FreeRoomState.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.sponsor = 0;
                object.agree = false;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.sponsor != null && message.hasOwnProperty("sponsor"))
                object.sponsor = message.sponsor;
            if (message.agree != null && message.hasOwnProperty("agree"))
                object.agree = message.agree;
            return object;
        };

        /**
         * Converts this FreeRoomState to JSON.
         * @function toJSON
         * @memberof Room.FreeRoomState
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FreeRoomState.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FreeRoomState;
    })();

    Room.RoomListReq = (function() {

        /**
         * Properties of a RoomListReq.
         * @memberof Room
         * @interface IRoomListReq
         */

        /**
         * Constructs a new RoomListReq.
         * @memberof Room
         * @classdesc Represents a RoomListReq.
         * @implements IRoomListReq
         * @constructor
         * @param {Room.IRoomListReq=} [properties] Properties to set
         */
        function RoomListReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new RoomListReq instance using the specified properties.
         * @function create
         * @memberof Room.RoomListReq
         * @static
         * @param {Room.IRoomListReq=} [properties] Properties to set
         * @returns {Room.RoomListReq} RoomListReq instance
         */
        RoomListReq.create = function create(properties) {
            return new RoomListReq(properties);
        };

        /**
         * Encodes the specified RoomListReq message. Does not implicitly {@link Room.RoomListReq.verify|verify} messages.
         * @function encode
         * @memberof Room.RoomListReq
         * @static
         * @param {Room.IRoomListReq} message RoomListReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomListReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified RoomListReq message, length delimited. Does not implicitly {@link Room.RoomListReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.RoomListReq
         * @static
         * @param {Room.IRoomListReq} message RoomListReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomListReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomListReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.RoomListReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.RoomListReq} RoomListReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomListReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.RoomListReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomListReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.RoomListReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.RoomListReq} RoomListReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomListReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomListReq message.
         * @function verify
         * @memberof Room.RoomListReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomListReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a RoomListReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.RoomListReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.RoomListReq} RoomListReq
         */
        RoomListReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.RoomListReq)
                return object;
            return new $root.Room.RoomListReq();
        };

        /**
         * Creates a plain object from a RoomListReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.RoomListReq
         * @static
         * @param {Room.RoomListReq} message RoomListReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomListReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this RoomListReq to JSON.
         * @function toJSON
         * @memberof Room.RoomListReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomListReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomListReq;
    })();

    Room.RoomListRsp = (function() {

        /**
         * Properties of a RoomListRsp.
         * @memberof Room
         * @interface IRoomListRsp
         * @property {Array.<Room.IRoomInfo>|null} [list] RoomListRsp list
         */

        /**
         * Constructs a new RoomListRsp.
         * @memberof Room
         * @classdesc Represents a RoomListRsp.
         * @implements IRoomListRsp
         * @constructor
         * @param {Room.IRoomListRsp=} [properties] Properties to set
         */
        function RoomListRsp(properties) {
            this.list = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RoomListRsp list.
         * @member {Array.<Room.IRoomInfo>} list
         * @memberof Room.RoomListRsp
         * @instance
         */
        RoomListRsp.prototype.list = $util.emptyArray;

        /**
         * Creates a new RoomListRsp instance using the specified properties.
         * @function create
         * @memberof Room.RoomListRsp
         * @static
         * @param {Room.IRoomListRsp=} [properties] Properties to set
         * @returns {Room.RoomListRsp} RoomListRsp instance
         */
        RoomListRsp.create = function create(properties) {
            return new RoomListRsp(properties);
        };

        /**
         * Encodes the specified RoomListRsp message. Does not implicitly {@link Room.RoomListRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.RoomListRsp
         * @static
         * @param {Room.IRoomListRsp} message RoomListRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomListRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.list != null && message.list.length)
                for (var i = 0; i < message.list.length; ++i)
                    $root.Room.RoomInfo.encode(message.list[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified RoomListRsp message, length delimited. Does not implicitly {@link Room.RoomListRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.RoomListRsp
         * @static
         * @param {Room.IRoomListRsp} message RoomListRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RoomListRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RoomListRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.RoomListRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.RoomListRsp} RoomListRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomListRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.RoomListRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.list && message.list.length))
                        message.list = [];
                    message.list.push($root.Room.RoomInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RoomListRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.RoomListRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.RoomListRsp} RoomListRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RoomListRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RoomListRsp message.
         * @function verify
         * @memberof Room.RoomListRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RoomListRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.list != null && message.hasOwnProperty("list")) {
                if (!Array.isArray(message.list))
                    return "list: array expected";
                for (var i = 0; i < message.list.length; ++i) {
                    var error = $root.Room.RoomInfo.verify(message.list[i]);
                    if (error)
                        return "list." + error;
                }
            }
            return null;
        };

        /**
         * Creates a RoomListRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.RoomListRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.RoomListRsp} RoomListRsp
         */
        RoomListRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.RoomListRsp)
                return object;
            var message = new $root.Room.RoomListRsp();
            if (object.list) {
                if (!Array.isArray(object.list))
                    throw TypeError(".Room.RoomListRsp.list: array expected");
                message.list = [];
                for (var i = 0; i < object.list.length; ++i) {
                    if (typeof object.list[i] !== "object")
                        throw TypeError(".Room.RoomListRsp.list: object expected");
                    message.list[i] = $root.Room.RoomInfo.fromObject(object.list[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a RoomListRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.RoomListRsp
         * @static
         * @param {Room.RoomListRsp} message RoomListRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RoomListRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.list = [];
            if (message.list && message.list.length) {
                object.list = [];
                for (var j = 0; j < message.list.length; ++j)
                    object.list[j] = $root.Room.RoomInfo.toObject(message.list[j], options);
            }
            return object;
        };

        /**
         * Converts this RoomListRsp to JSON.
         * @function toJSON
         * @memberof Room.RoomListRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RoomListRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RoomListRsp;
    })();

    Room.EnterReq = (function() {

        /**
         * Properties of an EnterReq.
         * @memberof Room
         * @interface IEnterReq
         * @property {number|null} [roomId] EnterReq roomId
         * @property {number|null} [posIndex] EnterReq posIndex
         * @property {number|null} [coin] EnterReq coin
         */

        /**
         * Constructs a new EnterReq.
         * @memberof Room
         * @classdesc Represents an EnterReq.
         * @implements IEnterReq
         * @constructor
         * @param {Room.IEnterReq=} [properties] Properties to set
         */
        function EnterReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnterReq roomId.
         * @member {number} roomId
         * @memberof Room.EnterReq
         * @instance
         */
        EnterReq.prototype.roomId = 0;

        /**
         * EnterReq posIndex.
         * @member {number} posIndex
         * @memberof Room.EnterReq
         * @instance
         */
        EnterReq.prototype.posIndex = 0;

        /**
         * EnterReq coin.
         * @member {number} coin
         * @memberof Room.EnterReq
         * @instance
         */
        EnterReq.prototype.coin = 0;

        /**
         * Creates a new EnterReq instance using the specified properties.
         * @function create
         * @memberof Room.EnterReq
         * @static
         * @param {Room.IEnterReq=} [properties] Properties to set
         * @returns {Room.EnterReq} EnterReq instance
         */
        EnterReq.create = function create(properties) {
            return new EnterReq(properties);
        };

        /**
         * Encodes the specified EnterReq message. Does not implicitly {@link Room.EnterReq.verify|verify} messages.
         * @function encode
         * @memberof Room.EnterReq
         * @static
         * @param {Room.IEnterReq} message EnterReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnterReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomId);
            if (message.posIndex != null && message.hasOwnProperty("posIndex"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.posIndex);
            if (message.coin != null && message.hasOwnProperty("coin"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.coin);
            return writer;
        };

        /**
         * Encodes the specified EnterReq message, length delimited. Does not implicitly {@link Room.EnterReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.EnterReq
         * @static
         * @param {Room.IEnterReq} message EnterReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnterReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EnterReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.EnterReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.EnterReq} EnterReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnterReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.EnterReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomId = reader.int32();
                    break;
                case 2:
                    message.posIndex = reader.int32();
                    break;
                case 3:
                    message.coin = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EnterReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.EnterReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.EnterReq} EnterReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnterReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EnterReq message.
         * @function verify
         * @memberof Room.EnterReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EnterReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isInteger(message.roomId))
                    return "roomId: integer expected";
            if (message.posIndex != null && message.hasOwnProperty("posIndex"))
                if (!$util.isInteger(message.posIndex))
                    return "posIndex: integer expected";
            if (message.coin != null && message.hasOwnProperty("coin"))
                if (!$util.isInteger(message.coin))
                    return "coin: integer expected";
            return null;
        };

        /**
         * Creates an EnterReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.EnterReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.EnterReq} EnterReq
         */
        EnterReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.EnterReq)
                return object;
            var message = new $root.Room.EnterReq();
            if (object.roomId != null)
                message.roomId = object.roomId | 0;
            if (object.posIndex != null)
                message.posIndex = object.posIndex | 0;
            if (object.coin != null)
                message.coin = object.coin | 0;
            return message;
        };

        /**
         * Creates a plain object from an EnterReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.EnterReq
         * @static
         * @param {Room.EnterReq} message EnterReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnterReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.roomId = 0;
                object.posIndex = 0;
                object.coin = 0;
            }
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            if (message.posIndex != null && message.hasOwnProperty("posIndex"))
                object.posIndex = message.posIndex;
            if (message.coin != null && message.hasOwnProperty("coin"))
                object.coin = message.coin;
            return object;
        };

        /**
         * Converts this EnterReq to JSON.
         * @function toJSON
         * @memberof Room.EnterReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnterReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnterReq;
    })();

    Room.EnterRsp = (function() {

        /**
         * Properties of an EnterRsp.
         * @memberof Room
         * @interface IEnterRsp
         * @property {string|null} [errNo] EnterRsp errNo
         */

        /**
         * Constructs a new EnterRsp.
         * @memberof Room
         * @classdesc Represents an EnterRsp.
         * @implements IEnterRsp
         * @constructor
         * @param {Room.IEnterRsp=} [properties] Properties to set
         */
        function EnterRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnterRsp errNo.
         * @member {string} errNo
         * @memberof Room.EnterRsp
         * @instance
         */
        EnterRsp.prototype.errNo = "";

        /**
         * Creates a new EnterRsp instance using the specified properties.
         * @function create
         * @memberof Room.EnterRsp
         * @static
         * @param {Room.IEnterRsp=} [properties] Properties to set
         * @returns {Room.EnterRsp} EnterRsp instance
         */
        EnterRsp.create = function create(properties) {
            return new EnterRsp(properties);
        };

        /**
         * Encodes the specified EnterRsp message. Does not implicitly {@link Room.EnterRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.EnterRsp
         * @static
         * @param {Room.IEnterRsp} message EnterRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnterRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified EnterRsp message, length delimited. Does not implicitly {@link Room.EnterRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.EnterRsp
         * @static
         * @param {Room.IEnterRsp} message EnterRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnterRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EnterRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.EnterRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.EnterRsp} EnterRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnterRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.EnterRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EnterRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.EnterRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.EnterRsp} EnterRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnterRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EnterRsp message.
         * @function verify
         * @memberof Room.EnterRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EnterRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates an EnterRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.EnterRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.EnterRsp} EnterRsp
         */
        EnterRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.EnterRsp)
                return object;
            var message = new $root.Room.EnterRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from an EnterRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.EnterRsp
         * @static
         * @param {Room.EnterRsp} message EnterRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnterRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this EnterRsp to JSON.
         * @function toJSON
         * @memberof Room.EnterRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnterRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnterRsp;
    })();

    Room.LeaveReq = (function() {

        /**
         * Properties of a LeaveReq.
         * @memberof Room
         * @interface ILeaveReq
         */

        /**
         * Constructs a new LeaveReq.
         * @memberof Room
         * @classdesc Represents a LeaveReq.
         * @implements ILeaveReq
         * @constructor
         * @param {Room.ILeaveReq=} [properties] Properties to set
         */
        function LeaveReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new LeaveReq instance using the specified properties.
         * @function create
         * @memberof Room.LeaveReq
         * @static
         * @param {Room.ILeaveReq=} [properties] Properties to set
         * @returns {Room.LeaveReq} LeaveReq instance
         */
        LeaveReq.create = function create(properties) {
            return new LeaveReq(properties);
        };

        /**
         * Encodes the specified LeaveReq message. Does not implicitly {@link Room.LeaveReq.verify|verify} messages.
         * @function encode
         * @memberof Room.LeaveReq
         * @static
         * @param {Room.ILeaveReq} message LeaveReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified LeaveReq message, length delimited. Does not implicitly {@link Room.LeaveReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.LeaveReq
         * @static
         * @param {Room.ILeaveReq} message LeaveReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LeaveReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.LeaveReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.LeaveReq} LeaveReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.LeaveReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LeaveReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.LeaveReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.LeaveReq} LeaveReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LeaveReq message.
         * @function verify
         * @memberof Room.LeaveReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LeaveReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a LeaveReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.LeaveReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.LeaveReq} LeaveReq
         */
        LeaveReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.LeaveReq)
                return object;
            return new $root.Room.LeaveReq();
        };

        /**
         * Creates a plain object from a LeaveReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.LeaveReq
         * @static
         * @param {Room.LeaveReq} message LeaveReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LeaveReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this LeaveReq to JSON.
         * @function toJSON
         * @memberof Room.LeaveReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LeaveReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LeaveReq;
    })();

    Room.LeaveRsp = (function() {

        /**
         * Properties of a LeaveRsp.
         * @memberof Room
         * @interface ILeaveRsp
         * @property {string|null} [errNo] LeaveRsp errNo
         */

        /**
         * Constructs a new LeaveRsp.
         * @memberof Room
         * @classdesc Represents a LeaveRsp.
         * @implements ILeaveRsp
         * @constructor
         * @param {Room.ILeaveRsp=} [properties] Properties to set
         */
        function LeaveRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LeaveRsp errNo.
         * @member {string} errNo
         * @memberof Room.LeaveRsp
         * @instance
         */
        LeaveRsp.prototype.errNo = "";

        /**
         * Creates a new LeaveRsp instance using the specified properties.
         * @function create
         * @memberof Room.LeaveRsp
         * @static
         * @param {Room.ILeaveRsp=} [properties] Properties to set
         * @returns {Room.LeaveRsp} LeaveRsp instance
         */
        LeaveRsp.create = function create(properties) {
            return new LeaveRsp(properties);
        };

        /**
         * Encodes the specified LeaveRsp message. Does not implicitly {@link Room.LeaveRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.LeaveRsp
         * @static
         * @param {Room.ILeaveRsp} message LeaveRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified LeaveRsp message, length delimited. Does not implicitly {@link Room.LeaveRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.LeaveRsp
         * @static
         * @param {Room.ILeaveRsp} message LeaveRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LeaveRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.LeaveRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.LeaveRsp} LeaveRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.LeaveRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a LeaveRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.LeaveRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.LeaveRsp} LeaveRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LeaveRsp message.
         * @function verify
         * @memberof Room.LeaveRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LeaveRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a LeaveRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.LeaveRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.LeaveRsp} LeaveRsp
         */
        LeaveRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.LeaveRsp)
                return object;
            var message = new $root.Room.LeaveRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a LeaveRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.LeaveRsp
         * @static
         * @param {Room.LeaveRsp} message LeaveRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LeaveRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this LeaveRsp to JSON.
         * @function toJSON
         * @memberof Room.LeaveRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LeaveRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LeaveRsp;
    })();

    Room.ReadyReq = (function() {

        /**
         * Properties of a ReadyReq.
         * @memberof Room
         * @interface IReadyReq
         * @property {number|null} [isReady] ReadyReq isReady
         */

        /**
         * Constructs a new ReadyReq.
         * @memberof Room
         * @classdesc Represents a ReadyReq.
         * @implements IReadyReq
         * @constructor
         * @param {Room.IReadyReq=} [properties] Properties to set
         */
        function ReadyReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReadyReq isReady.
         * @member {number} isReady
         * @memberof Room.ReadyReq
         * @instance
         */
        ReadyReq.prototype.isReady = 0;

        /**
         * Creates a new ReadyReq instance using the specified properties.
         * @function create
         * @memberof Room.ReadyReq
         * @static
         * @param {Room.IReadyReq=} [properties] Properties to set
         * @returns {Room.ReadyReq} ReadyReq instance
         */
        ReadyReq.create = function create(properties) {
            return new ReadyReq(properties);
        };

        /**
         * Encodes the specified ReadyReq message. Does not implicitly {@link Room.ReadyReq.verify|verify} messages.
         * @function encode
         * @memberof Room.ReadyReq
         * @static
         * @param {Room.IReadyReq} message ReadyReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadyReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.isReady != null && message.hasOwnProperty("isReady"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.isReady);
            return writer;
        };

        /**
         * Encodes the specified ReadyReq message, length delimited. Does not implicitly {@link Room.ReadyReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ReadyReq
         * @static
         * @param {Room.IReadyReq} message ReadyReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadyReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadyReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ReadyReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ReadyReq} ReadyReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadyReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ReadyReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.isReady = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadyReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ReadyReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ReadyReq} ReadyReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadyReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadyReq message.
         * @function verify
         * @memberof Room.ReadyReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadyReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.isReady != null && message.hasOwnProperty("isReady"))
                if (!$util.isInteger(message.isReady))
                    return "isReady: integer expected";
            return null;
        };

        /**
         * Creates a ReadyReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ReadyReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ReadyReq} ReadyReq
         */
        ReadyReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ReadyReq)
                return object;
            var message = new $root.Room.ReadyReq();
            if (object.isReady != null)
                message.isReady = object.isReady | 0;
            return message;
        };

        /**
         * Creates a plain object from a ReadyReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ReadyReq
         * @static
         * @param {Room.ReadyReq} message ReadyReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadyReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.isReady = 0;
            if (message.isReady != null && message.hasOwnProperty("isReady"))
                object.isReady = message.isReady;
            return object;
        };

        /**
         * Converts this ReadyReq to JSON.
         * @function toJSON
         * @memberof Room.ReadyReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadyReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReadyReq;
    })();

    Room.ReadyRsp = (function() {

        /**
         * Properties of a ReadyRsp.
         * @memberof Room
         * @interface IReadyRsp
         * @property {string|null} [errNo] ReadyRsp errNo
         */

        /**
         * Constructs a new ReadyRsp.
         * @memberof Room
         * @classdesc Represents a ReadyRsp.
         * @implements IReadyRsp
         * @constructor
         * @param {Room.IReadyRsp=} [properties] Properties to set
         */
        function ReadyRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReadyRsp errNo.
         * @member {string} errNo
         * @memberof Room.ReadyRsp
         * @instance
         */
        ReadyRsp.prototype.errNo = "";

        /**
         * Creates a new ReadyRsp instance using the specified properties.
         * @function create
         * @memberof Room.ReadyRsp
         * @static
         * @param {Room.IReadyRsp=} [properties] Properties to set
         * @returns {Room.ReadyRsp} ReadyRsp instance
         */
        ReadyRsp.create = function create(properties) {
            return new ReadyRsp(properties);
        };

        /**
         * Encodes the specified ReadyRsp message. Does not implicitly {@link Room.ReadyRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.ReadyRsp
         * @static
         * @param {Room.IReadyRsp} message ReadyRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadyRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified ReadyRsp message, length delimited. Does not implicitly {@link Room.ReadyRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ReadyRsp
         * @static
         * @param {Room.IReadyRsp} message ReadyRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadyRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadyRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ReadyRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ReadyRsp} ReadyRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadyRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ReadyRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadyRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ReadyRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ReadyRsp} ReadyRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadyRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadyRsp message.
         * @function verify
         * @memberof Room.ReadyRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadyRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a ReadyRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ReadyRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ReadyRsp} ReadyRsp
         */
        ReadyRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ReadyRsp)
                return object;
            var message = new $root.Room.ReadyRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a ReadyRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ReadyRsp
         * @static
         * @param {Room.ReadyRsp} message ReadyRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadyRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this ReadyRsp to JSON.
         * @function toJSON
         * @memberof Room.ReadyRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadyRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReadyRsp;
    })();

    Room.CheckReq = (function() {

        /**
         * Properties of a CheckReq.
         * @memberof Room
         * @interface ICheckReq
         * @property {number|null} [playerId] CheckReq playerId
         */

        /**
         * Constructs a new CheckReq.
         * @memberof Room
         * @classdesc Represents a CheckReq.
         * @implements ICheckReq
         * @constructor
         * @param {Room.ICheckReq=} [properties] Properties to set
         */
        function CheckReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CheckReq playerId.
         * @member {number} playerId
         * @memberof Room.CheckReq
         * @instance
         */
        CheckReq.prototype.playerId = 0;

        /**
         * Creates a new CheckReq instance using the specified properties.
         * @function create
         * @memberof Room.CheckReq
         * @static
         * @param {Room.ICheckReq=} [properties] Properties to set
         * @returns {Room.CheckReq} CheckReq instance
         */
        CheckReq.create = function create(properties) {
            return new CheckReq(properties);
        };

        /**
         * Encodes the specified CheckReq message. Does not implicitly {@link Room.CheckReq.verify|verify} messages.
         * @function encode
         * @memberof Room.CheckReq
         * @static
         * @param {Room.ICheckReq} message CheckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified CheckReq message, length delimited. Does not implicitly {@link Room.CheckReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CheckReq
         * @static
         * @param {Room.ICheckReq} message CheckReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CheckReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CheckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CheckReq} CheckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CheckReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CheckReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CheckReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CheckReq} CheckReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CheckReq message.
         * @function verify
         * @memberof Room.CheckReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CheckReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a CheckReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CheckReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CheckReq} CheckReq
         */
        CheckReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CheckReq)
                return object;
            var message = new $root.Room.CheckReq();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a CheckReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CheckReq
         * @static
         * @param {Room.CheckReq} message CheckReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CheckReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this CheckReq to JSON.
         * @function toJSON
         * @memberof Room.CheckReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CheckReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CheckReq;
    })();

    Room.CheckRsp = (function() {

        /**
         * Properties of a CheckRsp.
         * @memberof Room
         * @interface ICheckRsp
         * @property {number|null} [roomId] CheckRsp roomId
         */

        /**
         * Constructs a new CheckRsp.
         * @memberof Room
         * @classdesc Represents a CheckRsp.
         * @implements ICheckRsp
         * @constructor
         * @param {Room.ICheckRsp=} [properties] Properties to set
         */
        function CheckRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CheckRsp roomId.
         * @member {number} roomId
         * @memberof Room.CheckRsp
         * @instance
         */
        CheckRsp.prototype.roomId = 0;

        /**
         * Creates a new CheckRsp instance using the specified properties.
         * @function create
         * @memberof Room.CheckRsp
         * @static
         * @param {Room.ICheckRsp=} [properties] Properties to set
         * @returns {Room.CheckRsp} CheckRsp instance
         */
        CheckRsp.create = function create(properties) {
            return new CheckRsp(properties);
        };

        /**
         * Encodes the specified CheckRsp message. Does not implicitly {@link Room.CheckRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.CheckRsp
         * @static
         * @param {Room.ICheckRsp} message CheckRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.roomId);
            return writer;
        };

        /**
         * Encodes the specified CheckRsp message, length delimited. Does not implicitly {@link Room.CheckRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CheckRsp
         * @static
         * @param {Room.ICheckRsp} message CheckRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CheckRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CheckRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CheckRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CheckRsp} CheckRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CheckRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CheckRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CheckRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CheckRsp} CheckRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CheckRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CheckRsp message.
         * @function verify
         * @memberof Room.CheckRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CheckRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                if (!$util.isInteger(message.roomId))
                    return "roomId: integer expected";
            return null;
        };

        /**
         * Creates a CheckRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CheckRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CheckRsp} CheckRsp
         */
        CheckRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CheckRsp)
                return object;
            var message = new $root.Room.CheckRsp();
            if (object.roomId != null)
                message.roomId = object.roomId | 0;
            return message;
        };

        /**
         * Creates a plain object from a CheckRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CheckRsp
         * @static
         * @param {Room.CheckRsp} message CheckRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CheckRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.roomId = 0;
            if (message.roomId != null && message.hasOwnProperty("roomId"))
                object.roomId = message.roomId;
            return object;
        };

        /**
         * Converts this CheckRsp to JSON.
         * @function toJSON
         * @memberof Room.CheckRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CheckRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CheckRsp;
    })();

    Room.StartReq = (function() {

        /**
         * Properties of a StartReq.
         * @memberof Room
         * @interface IStartReq
         */

        /**
         * Constructs a new StartReq.
         * @memberof Room
         * @classdesc Represents a StartReq.
         * @implements IStartReq
         * @constructor
         * @param {Room.IStartReq=} [properties] Properties to set
         */
        function StartReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new StartReq instance using the specified properties.
         * @function create
         * @memberof Room.StartReq
         * @static
         * @param {Room.IStartReq=} [properties] Properties to set
         * @returns {Room.StartReq} StartReq instance
         */
        StartReq.create = function create(properties) {
            return new StartReq(properties);
        };

        /**
         * Encodes the specified StartReq message. Does not implicitly {@link Room.StartReq.verify|verify} messages.
         * @function encode
         * @memberof Room.StartReq
         * @static
         * @param {Room.IStartReq} message StartReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified StartReq message, length delimited. Does not implicitly {@link Room.StartReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.StartReq
         * @static
         * @param {Room.IStartReq} message StartReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.StartReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.StartReq} StartReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.StartReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.StartReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.StartReq} StartReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartReq message.
         * @function verify
         * @memberof Room.StartReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a StartReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.StartReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.StartReq} StartReq
         */
        StartReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.StartReq)
                return object;
            return new $root.Room.StartReq();
        };

        /**
         * Creates a plain object from a StartReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.StartReq
         * @static
         * @param {Room.StartReq} message StartReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this StartReq to JSON.
         * @function toJSON
         * @memberof Room.StartReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StartReq;
    })();

    Room.StartRsp = (function() {

        /**
         * Properties of a StartRsp.
         * @memberof Room
         * @interface IStartRsp
         * @property {string|null} [errNo] StartRsp errNo
         */

        /**
         * Constructs a new StartRsp.
         * @memberof Room
         * @classdesc Represents a StartRsp.
         * @implements IStartRsp
         * @constructor
         * @param {Room.IStartRsp=} [properties] Properties to set
         */
        function StartRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StartRsp errNo.
         * @member {string} errNo
         * @memberof Room.StartRsp
         * @instance
         */
        StartRsp.prototype.errNo = "";

        /**
         * Creates a new StartRsp instance using the specified properties.
         * @function create
         * @memberof Room.StartRsp
         * @static
         * @param {Room.IStartRsp=} [properties] Properties to set
         * @returns {Room.StartRsp} StartRsp instance
         */
        StartRsp.create = function create(properties) {
            return new StartRsp(properties);
        };

        /**
         * Encodes the specified StartRsp message. Does not implicitly {@link Room.StartRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.StartRsp
         * @static
         * @param {Room.IStartRsp} message StartRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified StartRsp message, length delimited. Does not implicitly {@link Room.StartRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.StartRsp
         * @static
         * @param {Room.IStartRsp} message StartRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.StartRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.StartRsp} StartRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.StartRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.StartRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.StartRsp} StartRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartRsp message.
         * @function verify
         * @memberof Room.StartRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a StartRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.StartRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.StartRsp} StartRsp
         */
        StartRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.StartRsp)
                return object;
            var message = new $root.Room.StartRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a StartRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.StartRsp
         * @static
         * @param {Room.StartRsp} message StartRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this StartRsp to JSON.
         * @function toJSON
         * @memberof Room.StartRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StartRsp;
    })();

    Room.FreeReq = (function() {

        /**
         * Properties of a FreeReq.
         * @memberof Room
         * @interface IFreeReq
         * @property {boolean|null} [agree] FreeReq agree
         */

        /**
         * Constructs a new FreeReq.
         * @memberof Room
         * @classdesc Represents a FreeReq.
         * @implements IFreeReq
         * @constructor
         * @param {Room.IFreeReq=} [properties] Properties to set
         */
        function FreeReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FreeReq agree.
         * @member {boolean} agree
         * @memberof Room.FreeReq
         * @instance
         */
        FreeReq.prototype.agree = false;

        /**
         * Creates a new FreeReq instance using the specified properties.
         * @function create
         * @memberof Room.FreeReq
         * @static
         * @param {Room.IFreeReq=} [properties] Properties to set
         * @returns {Room.FreeReq} FreeReq instance
         */
        FreeReq.create = function create(properties) {
            return new FreeReq(properties);
        };

        /**
         * Encodes the specified FreeReq message. Does not implicitly {@link Room.FreeReq.verify|verify} messages.
         * @function encode
         * @memberof Room.FreeReq
         * @static
         * @param {Room.IFreeReq} message FreeReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.agree != null && message.hasOwnProperty("agree"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.agree);
            return writer;
        };

        /**
         * Encodes the specified FreeReq message, length delimited. Does not implicitly {@link Room.FreeReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.FreeReq
         * @static
         * @param {Room.IFreeReq} message FreeReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FreeReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.FreeReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.FreeReq} FreeReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.FreeReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.agree = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FreeReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.FreeReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.FreeReq} FreeReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FreeReq message.
         * @function verify
         * @memberof Room.FreeReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FreeReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.agree != null && message.hasOwnProperty("agree"))
                if (typeof message.agree !== "boolean")
                    return "agree: boolean expected";
            return null;
        };

        /**
         * Creates a FreeReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.FreeReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.FreeReq} FreeReq
         */
        FreeReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.FreeReq)
                return object;
            var message = new $root.Room.FreeReq();
            if (object.agree != null)
                message.agree = Boolean(object.agree);
            return message;
        };

        /**
         * Creates a plain object from a FreeReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.FreeReq
         * @static
         * @param {Room.FreeReq} message FreeReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FreeReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.agree = false;
            if (message.agree != null && message.hasOwnProperty("agree"))
                object.agree = message.agree;
            return object;
        };

        /**
         * Converts this FreeReq to JSON.
         * @function toJSON
         * @memberof Room.FreeReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FreeReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FreeReq;
    })();

    Room.FreeRsp = (function() {

        /**
         * Properties of a FreeRsp.
         * @memberof Room
         * @interface IFreeRsp
         * @property {string|null} [errNo] FreeRsp errNo
         * @property {boolean|null} [agree] FreeRsp agree
         */

        /**
         * Constructs a new FreeRsp.
         * @memberof Room
         * @classdesc Represents a FreeRsp.
         * @implements IFreeRsp
         * @constructor
         * @param {Room.IFreeRsp=} [properties] Properties to set
         */
        function FreeRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FreeRsp errNo.
         * @member {string} errNo
         * @memberof Room.FreeRsp
         * @instance
         */
        FreeRsp.prototype.errNo = "";

        /**
         * FreeRsp agree.
         * @member {boolean} agree
         * @memberof Room.FreeRsp
         * @instance
         */
        FreeRsp.prototype.agree = false;

        /**
         * Creates a new FreeRsp instance using the specified properties.
         * @function create
         * @memberof Room.FreeRsp
         * @static
         * @param {Room.IFreeRsp=} [properties] Properties to set
         * @returns {Room.FreeRsp} FreeRsp instance
         */
        FreeRsp.create = function create(properties) {
            return new FreeRsp(properties);
        };

        /**
         * Encodes the specified FreeRsp message. Does not implicitly {@link Room.FreeRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.FreeRsp
         * @static
         * @param {Room.IFreeRsp} message FreeRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            if (message.agree != null && message.hasOwnProperty("agree"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.agree);
            return writer;
        };

        /**
         * Encodes the specified FreeRsp message, length delimited. Does not implicitly {@link Room.FreeRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.FreeRsp
         * @static
         * @param {Room.IFreeRsp} message FreeRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FreeRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.FreeRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.FreeRsp} FreeRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.FreeRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                case 2:
                    message.agree = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FreeRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.FreeRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.FreeRsp} FreeRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FreeRsp message.
         * @function verify
         * @memberof Room.FreeRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FreeRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            if (message.agree != null && message.hasOwnProperty("agree"))
                if (typeof message.agree !== "boolean")
                    return "agree: boolean expected";
            return null;
        };

        /**
         * Creates a FreeRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.FreeRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.FreeRsp} FreeRsp
         */
        FreeRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.FreeRsp)
                return object;
            var message = new $root.Room.FreeRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            if (object.agree != null)
                message.agree = Boolean(object.agree);
            return message;
        };

        /**
         * Creates a plain object from a FreeRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.FreeRsp
         * @static
         * @param {Room.FreeRsp} message FreeRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FreeRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.errNo = "";
                object.agree = false;
            }
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            if (message.agree != null && message.hasOwnProperty("agree"))
                object.agree = message.agree;
            return object;
        };

        /**
         * Converts this FreeRsp to JSON.
         * @function toJSON
         * @memberof Room.FreeRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FreeRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FreeRsp;
    })();

    Room.KickPlayerReq = (function() {

        /**
         * Properties of a KickPlayerReq.
         * @memberof Room
         * @interface IKickPlayerReq
         * @property {number|null} [playerId] KickPlayerReq playerId
         */

        /**
         * Constructs a new KickPlayerReq.
         * @memberof Room
         * @classdesc Represents a KickPlayerReq.
         * @implements IKickPlayerReq
         * @constructor
         * @param {Room.IKickPlayerReq=} [properties] Properties to set
         */
        function KickPlayerReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KickPlayerReq playerId.
         * @member {number} playerId
         * @memberof Room.KickPlayerReq
         * @instance
         */
        KickPlayerReq.prototype.playerId = 0;

        /**
         * Creates a new KickPlayerReq instance using the specified properties.
         * @function create
         * @memberof Room.KickPlayerReq
         * @static
         * @param {Room.IKickPlayerReq=} [properties] Properties to set
         * @returns {Room.KickPlayerReq} KickPlayerReq instance
         */
        KickPlayerReq.create = function create(properties) {
            return new KickPlayerReq(properties);
        };

        /**
         * Encodes the specified KickPlayerReq message. Does not implicitly {@link Room.KickPlayerReq.verify|verify} messages.
         * @function encode
         * @memberof Room.KickPlayerReq
         * @static
         * @param {Room.IKickPlayerReq} message KickPlayerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KickPlayerReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified KickPlayerReq message, length delimited. Does not implicitly {@link Room.KickPlayerReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.KickPlayerReq
         * @static
         * @param {Room.IKickPlayerReq} message KickPlayerReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KickPlayerReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KickPlayerReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.KickPlayerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.KickPlayerReq} KickPlayerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KickPlayerReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.KickPlayerReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KickPlayerReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.KickPlayerReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.KickPlayerReq} KickPlayerReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KickPlayerReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KickPlayerReq message.
         * @function verify
         * @memberof Room.KickPlayerReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KickPlayerReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a KickPlayerReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.KickPlayerReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.KickPlayerReq} KickPlayerReq
         */
        KickPlayerReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.KickPlayerReq)
                return object;
            var message = new $root.Room.KickPlayerReq();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a KickPlayerReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.KickPlayerReq
         * @static
         * @param {Room.KickPlayerReq} message KickPlayerReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KickPlayerReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this KickPlayerReq to JSON.
         * @function toJSON
         * @memberof Room.KickPlayerReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KickPlayerReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return KickPlayerReq;
    })();

    Room.KickPlayerRsp = (function() {

        /**
         * Properties of a KickPlayerRsp.
         * @memberof Room
         * @interface IKickPlayerRsp
         * @property {string|null} [errNo] KickPlayerRsp errNo
         */

        /**
         * Constructs a new KickPlayerRsp.
         * @memberof Room
         * @classdesc Represents a KickPlayerRsp.
         * @implements IKickPlayerRsp
         * @constructor
         * @param {Room.IKickPlayerRsp=} [properties] Properties to set
         */
        function KickPlayerRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KickPlayerRsp errNo.
         * @member {string} errNo
         * @memberof Room.KickPlayerRsp
         * @instance
         */
        KickPlayerRsp.prototype.errNo = "";

        /**
         * Creates a new KickPlayerRsp instance using the specified properties.
         * @function create
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {Room.IKickPlayerRsp=} [properties] Properties to set
         * @returns {Room.KickPlayerRsp} KickPlayerRsp instance
         */
        KickPlayerRsp.create = function create(properties) {
            return new KickPlayerRsp(properties);
        };

        /**
         * Encodes the specified KickPlayerRsp message. Does not implicitly {@link Room.KickPlayerRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {Room.IKickPlayerRsp} message KickPlayerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KickPlayerRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified KickPlayerRsp message, length delimited. Does not implicitly {@link Room.KickPlayerRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {Room.IKickPlayerRsp} message KickPlayerRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KickPlayerRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KickPlayerRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.KickPlayerRsp} KickPlayerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KickPlayerRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.KickPlayerRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KickPlayerRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.KickPlayerRsp} KickPlayerRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KickPlayerRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KickPlayerRsp message.
         * @function verify
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KickPlayerRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a KickPlayerRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.KickPlayerRsp} KickPlayerRsp
         */
        KickPlayerRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.KickPlayerRsp)
                return object;
            var message = new $root.Room.KickPlayerRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a KickPlayerRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.KickPlayerRsp
         * @static
         * @param {Room.KickPlayerRsp} message KickPlayerRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KickPlayerRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this KickPlayerRsp to JSON.
         * @function toJSON
         * @memberof Room.KickPlayerRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KickPlayerRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return KickPlayerRsp;
    })();

    Room.ChatMsgReq = (function() {

        /**
         * Properties of a ChatMsgReq.
         * @memberof Room
         * @interface IChatMsgReq
         * @property {Room.IChatMsg|null} [chatMsg] ChatMsgReq chatMsg
         */

        /**
         * Constructs a new ChatMsgReq.
         * @memberof Room
         * @classdesc Represents a ChatMsgReq.
         * @implements IChatMsgReq
         * @constructor
         * @param {Room.IChatMsgReq=} [properties] Properties to set
         */
        function ChatMsgReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatMsgReq chatMsg.
         * @member {Room.IChatMsg|null|undefined} chatMsg
         * @memberof Room.ChatMsgReq
         * @instance
         */
        ChatMsgReq.prototype.chatMsg = null;

        /**
         * Creates a new ChatMsgReq instance using the specified properties.
         * @function create
         * @memberof Room.ChatMsgReq
         * @static
         * @param {Room.IChatMsgReq=} [properties] Properties to set
         * @returns {Room.ChatMsgReq} ChatMsgReq instance
         */
        ChatMsgReq.create = function create(properties) {
            return new ChatMsgReq(properties);
        };

        /**
         * Encodes the specified ChatMsgReq message. Does not implicitly {@link Room.ChatMsgReq.verify|verify} messages.
         * @function encode
         * @memberof Room.ChatMsgReq
         * @static
         * @param {Room.IChatMsgReq} message ChatMsgReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsgReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.chatMsg != null && message.hasOwnProperty("chatMsg"))
                $root.Room.ChatMsg.encode(message.chatMsg, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ChatMsgReq message, length delimited. Does not implicitly {@link Room.ChatMsgReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ChatMsgReq
         * @static
         * @param {Room.IChatMsgReq} message ChatMsgReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsgReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatMsgReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ChatMsgReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ChatMsgReq} ChatMsgReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsgReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ChatMsgReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.chatMsg = $root.Room.ChatMsg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatMsgReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ChatMsgReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ChatMsgReq} ChatMsgReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsgReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatMsgReq message.
         * @function verify
         * @memberof Room.ChatMsgReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatMsgReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.chatMsg != null && message.hasOwnProperty("chatMsg")) {
                var error = $root.Room.ChatMsg.verify(message.chatMsg);
                if (error)
                    return "chatMsg." + error;
            }
            return null;
        };

        /**
         * Creates a ChatMsgReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ChatMsgReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ChatMsgReq} ChatMsgReq
         */
        ChatMsgReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ChatMsgReq)
                return object;
            var message = new $root.Room.ChatMsgReq();
            if (object.chatMsg != null) {
                if (typeof object.chatMsg !== "object")
                    throw TypeError(".Room.ChatMsgReq.chatMsg: object expected");
                message.chatMsg = $root.Room.ChatMsg.fromObject(object.chatMsg);
            }
            return message;
        };

        /**
         * Creates a plain object from a ChatMsgReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ChatMsgReq
         * @static
         * @param {Room.ChatMsgReq} message ChatMsgReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatMsgReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.chatMsg = null;
            if (message.chatMsg != null && message.hasOwnProperty("chatMsg"))
                object.chatMsg = $root.Room.ChatMsg.toObject(message.chatMsg, options);
            return object;
        };

        /**
         * Converts this ChatMsgReq to JSON.
         * @function toJSON
         * @memberof Room.ChatMsgReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatMsgReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChatMsgReq;
    })();

    Room.ChatMsgRsp = (function() {

        /**
         * Properties of a ChatMsgRsp.
         * @memberof Room
         * @interface IChatMsgRsp
         * @property {string|null} [errNo] ChatMsgRsp errNo
         */

        /**
         * Constructs a new ChatMsgRsp.
         * @memberof Room
         * @classdesc Represents a ChatMsgRsp.
         * @implements IChatMsgRsp
         * @constructor
         * @param {Room.IChatMsgRsp=} [properties] Properties to set
         */
        function ChatMsgRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatMsgRsp errNo.
         * @member {string} errNo
         * @memberof Room.ChatMsgRsp
         * @instance
         */
        ChatMsgRsp.prototype.errNo = "";

        /**
         * Creates a new ChatMsgRsp instance using the specified properties.
         * @function create
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {Room.IChatMsgRsp=} [properties] Properties to set
         * @returns {Room.ChatMsgRsp} ChatMsgRsp instance
         */
        ChatMsgRsp.create = function create(properties) {
            return new ChatMsgRsp(properties);
        };

        /**
         * Encodes the specified ChatMsgRsp message. Does not implicitly {@link Room.ChatMsgRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {Room.IChatMsgRsp} message ChatMsgRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsgRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified ChatMsgRsp message, length delimited. Does not implicitly {@link Room.ChatMsgRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {Room.IChatMsgRsp} message ChatMsgRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsgRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatMsgRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ChatMsgRsp} ChatMsgRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsgRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ChatMsgRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatMsgRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ChatMsgRsp} ChatMsgRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsgRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatMsgRsp message.
         * @function verify
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatMsgRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a ChatMsgRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ChatMsgRsp} ChatMsgRsp
         */
        ChatMsgRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ChatMsgRsp)
                return object;
            var message = new $root.Room.ChatMsgRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a ChatMsgRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ChatMsgRsp
         * @static
         * @param {Room.ChatMsgRsp} message ChatMsgRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatMsgRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this ChatMsgRsp to JSON.
         * @function toJSON
         * @memberof Room.ChatMsgRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatMsgRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChatMsgRsp;
    })();

    Room.CustomInfo = (function() {

        /**
         * Properties of a CustomInfo.
         * @memberof Room
         * @interface ICustomInfo
         * @property {number|null} [playerId] CustomInfo playerId
         * @property {string|null} [customInfo] CustomInfo customInfo
         */

        /**
         * Constructs a new CustomInfo.
         * @memberof Room
         * @classdesc Represents a CustomInfo.
         * @implements ICustomInfo
         * @constructor
         * @param {Room.ICustomInfo=} [properties] Properties to set
         */
        function CustomInfo(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomInfo playerId.
         * @member {number} playerId
         * @memberof Room.CustomInfo
         * @instance
         */
        CustomInfo.prototype.playerId = 0;

        /**
         * CustomInfo customInfo.
         * @member {string} customInfo
         * @memberof Room.CustomInfo
         * @instance
         */
        CustomInfo.prototype.customInfo = "";

        /**
         * Creates a new CustomInfo instance using the specified properties.
         * @function create
         * @memberof Room.CustomInfo
         * @static
         * @param {Room.ICustomInfo=} [properties] Properties to set
         * @returns {Room.CustomInfo} CustomInfo instance
         */
        CustomInfo.create = function create(properties) {
            return new CustomInfo(properties);
        };

        /**
         * Encodes the specified CustomInfo message. Does not implicitly {@link Room.CustomInfo.verify|verify} messages.
         * @function encode
         * @memberof Room.CustomInfo
         * @static
         * @param {Room.ICustomInfo} message CustomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfo.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.customInfo != null && message.hasOwnProperty("customInfo"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.customInfo);
            return writer;
        };

        /**
         * Encodes the specified CustomInfo message, length delimited. Does not implicitly {@link Room.CustomInfo.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CustomInfo
         * @static
         * @param {Room.ICustomInfo} message CustomInfo message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfo.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomInfo message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CustomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CustomInfo} CustomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfo.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CustomInfo();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.customInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomInfo message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CustomInfo
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CustomInfo} CustomInfo
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfo.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomInfo message.
         * @function verify
         * @memberof Room.CustomInfo
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomInfo.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.customInfo != null && message.hasOwnProperty("customInfo"))
                if (!$util.isString(message.customInfo))
                    return "customInfo: string expected";
            return null;
        };

        /**
         * Creates a CustomInfo message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CustomInfo
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CustomInfo} CustomInfo
         */
        CustomInfo.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CustomInfo)
                return object;
            var message = new $root.Room.CustomInfo();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.customInfo != null)
                message.customInfo = String(object.customInfo);
            return message;
        };

        /**
         * Creates a plain object from a CustomInfo message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CustomInfo
         * @static
         * @param {Room.CustomInfo} message CustomInfo
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomInfo.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.customInfo = "";
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.customInfo != null && message.hasOwnProperty("customInfo"))
                object.customInfo = message.customInfo;
            return object;
        };

        /**
         * Converts this CustomInfo to JSON.
         * @function toJSON
         * @memberof Room.CustomInfo
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomInfo.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomInfo;
    })();

    Room.CustomInfoChangeReq = (function() {

        /**
         * Properties of a CustomInfoChangeReq.
         * @memberof Room
         * @interface ICustomInfoChangeReq
         * @property {string|null} [customInfo] CustomInfoChangeReq customInfo
         */

        /**
         * Constructs a new CustomInfoChangeReq.
         * @memberof Room
         * @classdesc Represents a CustomInfoChangeReq.
         * @implements ICustomInfoChangeReq
         * @constructor
         * @param {Room.ICustomInfoChangeReq=} [properties] Properties to set
         */
        function CustomInfoChangeReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomInfoChangeReq customInfo.
         * @member {string} customInfo
         * @memberof Room.CustomInfoChangeReq
         * @instance
         */
        CustomInfoChangeReq.prototype.customInfo = "";

        /**
         * Creates a new CustomInfoChangeReq instance using the specified properties.
         * @function create
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {Room.ICustomInfoChangeReq=} [properties] Properties to set
         * @returns {Room.CustomInfoChangeReq} CustomInfoChangeReq instance
         */
        CustomInfoChangeReq.create = function create(properties) {
            return new CustomInfoChangeReq(properties);
        };

        /**
         * Encodes the specified CustomInfoChangeReq message. Does not implicitly {@link Room.CustomInfoChangeReq.verify|verify} messages.
         * @function encode
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {Room.ICustomInfoChangeReq} message CustomInfoChangeReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfoChangeReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customInfo != null && message.hasOwnProperty("customInfo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.customInfo);
            return writer;
        };

        /**
         * Encodes the specified CustomInfoChangeReq message, length delimited. Does not implicitly {@link Room.CustomInfoChangeReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {Room.ICustomInfoChangeReq} message CustomInfoChangeReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfoChangeReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomInfoChangeReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CustomInfoChangeReq} CustomInfoChangeReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfoChangeReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CustomInfoChangeReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.customInfo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomInfoChangeReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CustomInfoChangeReq} CustomInfoChangeReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfoChangeReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomInfoChangeReq message.
         * @function verify
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomInfoChangeReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customInfo != null && message.hasOwnProperty("customInfo"))
                if (!$util.isString(message.customInfo))
                    return "customInfo: string expected";
            return null;
        };

        /**
         * Creates a CustomInfoChangeReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CustomInfoChangeReq} CustomInfoChangeReq
         */
        CustomInfoChangeReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CustomInfoChangeReq)
                return object;
            var message = new $root.Room.CustomInfoChangeReq();
            if (object.customInfo != null)
                message.customInfo = String(object.customInfo);
            return message;
        };

        /**
         * Creates a plain object from a CustomInfoChangeReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CustomInfoChangeReq
         * @static
         * @param {Room.CustomInfoChangeReq} message CustomInfoChangeReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomInfoChangeReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.customInfo = "";
            if (message.customInfo != null && message.hasOwnProperty("customInfo"))
                object.customInfo = message.customInfo;
            return object;
        };

        /**
         * Converts this CustomInfoChangeReq to JSON.
         * @function toJSON
         * @memberof Room.CustomInfoChangeReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomInfoChangeReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomInfoChangeReq;
    })();

    Room.CustomInfoChangeRsp = (function() {

        /**
         * Properties of a CustomInfoChangeRsp.
         * @memberof Room
         * @interface ICustomInfoChangeRsp
         * @property {string|null} [errNo] CustomInfoChangeRsp errNo
         */

        /**
         * Constructs a new CustomInfoChangeRsp.
         * @memberof Room
         * @classdesc Represents a CustomInfoChangeRsp.
         * @implements ICustomInfoChangeRsp
         * @constructor
         * @param {Room.ICustomInfoChangeRsp=} [properties] Properties to set
         */
        function CustomInfoChangeRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomInfoChangeRsp errNo.
         * @member {string} errNo
         * @memberof Room.CustomInfoChangeRsp
         * @instance
         */
        CustomInfoChangeRsp.prototype.errNo = "";

        /**
         * Creates a new CustomInfoChangeRsp instance using the specified properties.
         * @function create
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {Room.ICustomInfoChangeRsp=} [properties] Properties to set
         * @returns {Room.CustomInfoChangeRsp} CustomInfoChangeRsp instance
         */
        CustomInfoChangeRsp.create = function create(properties) {
            return new CustomInfoChangeRsp(properties);
        };

        /**
         * Encodes the specified CustomInfoChangeRsp message. Does not implicitly {@link Room.CustomInfoChangeRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {Room.ICustomInfoChangeRsp} message CustomInfoChangeRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfoChangeRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified CustomInfoChangeRsp message, length delimited. Does not implicitly {@link Room.CustomInfoChangeRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {Room.ICustomInfoChangeRsp} message CustomInfoChangeRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfoChangeRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomInfoChangeRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CustomInfoChangeRsp} CustomInfoChangeRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfoChangeRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CustomInfoChangeRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomInfoChangeRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CustomInfoChangeRsp} CustomInfoChangeRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfoChangeRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomInfoChangeRsp message.
         * @function verify
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomInfoChangeRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a CustomInfoChangeRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CustomInfoChangeRsp} CustomInfoChangeRsp
         */
        CustomInfoChangeRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CustomInfoChangeRsp)
                return object;
            var message = new $root.Room.CustomInfoChangeRsp();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a CustomInfoChangeRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CustomInfoChangeRsp
         * @static
         * @param {Room.CustomInfoChangeRsp} message CustomInfoChangeRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomInfoChangeRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this CustomInfoChangeRsp to JSON.
         * @function toJSON
         * @memberof Room.CustomInfoChangeRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomInfoChangeRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomInfoChangeRsp;
    })();

    Room.CustomInfoChangeBroadcast = (function() {

        /**
         * Properties of a CustomInfoChangeBroadcast.
         * @memberof Room
         * @interface ICustomInfoChangeBroadcast
         * @property {Array.<Room.ICustomInfo>|null} [customInfoList] CustomInfoChangeBroadcast customInfoList
         */

        /**
         * Constructs a new CustomInfoChangeBroadcast.
         * @memberof Room
         * @classdesc Represents a CustomInfoChangeBroadcast.
         * @implements ICustomInfoChangeBroadcast
         * @constructor
         * @param {Room.ICustomInfoChangeBroadcast=} [properties] Properties to set
         */
        function CustomInfoChangeBroadcast(properties) {
            this.customInfoList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CustomInfoChangeBroadcast customInfoList.
         * @member {Array.<Room.ICustomInfo>} customInfoList
         * @memberof Room.CustomInfoChangeBroadcast
         * @instance
         */
        CustomInfoChangeBroadcast.prototype.customInfoList = $util.emptyArray;

        /**
         * Creates a new CustomInfoChangeBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {Room.ICustomInfoChangeBroadcast=} [properties] Properties to set
         * @returns {Room.CustomInfoChangeBroadcast} CustomInfoChangeBroadcast instance
         */
        CustomInfoChangeBroadcast.create = function create(properties) {
            return new CustomInfoChangeBroadcast(properties);
        };

        /**
         * Encodes the specified CustomInfoChangeBroadcast message. Does not implicitly {@link Room.CustomInfoChangeBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {Room.ICustomInfoChangeBroadcast} message CustomInfoChangeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfoChangeBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.customInfoList != null && message.customInfoList.length)
                for (var i = 0; i < message.customInfoList.length; ++i)
                    $root.Room.CustomInfo.encode(message.customInfoList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified CustomInfoChangeBroadcast message, length delimited. Does not implicitly {@link Room.CustomInfoChangeBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {Room.ICustomInfoChangeBroadcast} message CustomInfoChangeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CustomInfoChangeBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CustomInfoChangeBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CustomInfoChangeBroadcast} CustomInfoChangeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfoChangeBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CustomInfoChangeBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.customInfoList && message.customInfoList.length))
                        message.customInfoList = [];
                    message.customInfoList.push($root.Room.CustomInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CustomInfoChangeBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CustomInfoChangeBroadcast} CustomInfoChangeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CustomInfoChangeBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CustomInfoChangeBroadcast message.
         * @function verify
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CustomInfoChangeBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.customInfoList != null && message.hasOwnProperty("customInfoList")) {
                if (!Array.isArray(message.customInfoList))
                    return "customInfoList: array expected";
                for (var i = 0; i < message.customInfoList.length; ++i) {
                    var error = $root.Room.CustomInfo.verify(message.customInfoList[i]);
                    if (error)
                        return "customInfoList." + error;
                }
            }
            return null;
        };

        /**
         * Creates a CustomInfoChangeBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CustomInfoChangeBroadcast} CustomInfoChangeBroadcast
         */
        CustomInfoChangeBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CustomInfoChangeBroadcast)
                return object;
            var message = new $root.Room.CustomInfoChangeBroadcast();
            if (object.customInfoList) {
                if (!Array.isArray(object.customInfoList))
                    throw TypeError(".Room.CustomInfoChangeBroadcast.customInfoList: array expected");
                message.customInfoList = [];
                for (var i = 0; i < object.customInfoList.length; ++i) {
                    if (typeof object.customInfoList[i] !== "object")
                        throw TypeError(".Room.CustomInfoChangeBroadcast.customInfoList: object expected");
                    message.customInfoList[i] = $root.Room.CustomInfo.fromObject(object.customInfoList[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a CustomInfoChangeBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CustomInfoChangeBroadcast
         * @static
         * @param {Room.CustomInfoChangeBroadcast} message CustomInfoChangeBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CustomInfoChangeBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.customInfoList = [];
            if (message.customInfoList && message.customInfoList.length) {
                object.customInfoList = [];
                for (var j = 0; j < message.customInfoList.length; ++j)
                    object.customInfoList[j] = $root.Room.CustomInfo.toObject(message.customInfoList[j], options);
            }
            return object;
        };

        /**
         * Converts this CustomInfoChangeBroadcast to JSON.
         * @function toJSON
         * @memberof Room.CustomInfoChangeBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CustomInfoChangeBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CustomInfoChangeBroadcast;
    })();

    Room.IntrustReq = (function() {

        /**
         * Properties of an IntrustReq.
         * @memberof Room
         * @interface IIntrustReq
         * @property {number|null} [action] IntrustReq action
         */

        /**
         * Constructs a new IntrustReq.
         * @memberof Room
         * @classdesc Represents an IntrustReq.
         * @implements IIntrustReq
         * @constructor
         * @param {Room.IIntrustReq=} [properties] Properties to set
         */
        function IntrustReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IntrustReq action.
         * @member {number} action
         * @memberof Room.IntrustReq
         * @instance
         */
        IntrustReq.prototype.action = 0;

        /**
         * Creates a new IntrustReq instance using the specified properties.
         * @function create
         * @memberof Room.IntrustReq
         * @static
         * @param {Room.IIntrustReq=} [properties] Properties to set
         * @returns {Room.IntrustReq} IntrustReq instance
         */
        IntrustReq.create = function create(properties) {
            return new IntrustReq(properties);
        };

        /**
         * Encodes the specified IntrustReq message. Does not implicitly {@link Room.IntrustReq.verify|verify} messages.
         * @function encode
         * @memberof Room.IntrustReq
         * @static
         * @param {Room.IIntrustReq} message IntrustReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntrustReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.action != null && message.hasOwnProperty("action"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.action);
            return writer;
        };

        /**
         * Encodes the specified IntrustReq message, length delimited. Does not implicitly {@link Room.IntrustReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.IntrustReq
         * @static
         * @param {Room.IIntrustReq} message IntrustReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntrustReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IntrustReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.IntrustReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.IntrustReq} IntrustReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntrustReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.IntrustReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.action = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IntrustReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.IntrustReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.IntrustReq} IntrustReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntrustReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IntrustReq message.
         * @function verify
         * @memberof Room.IntrustReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IntrustReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.action != null && message.hasOwnProperty("action"))
                if (!$util.isInteger(message.action))
                    return "action: integer expected";
            return null;
        };

        /**
         * Creates an IntrustReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.IntrustReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.IntrustReq} IntrustReq
         */
        IntrustReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.IntrustReq)
                return object;
            var message = new $root.Room.IntrustReq();
            if (object.action != null)
                message.action = object.action | 0;
            return message;
        };

        /**
         * Creates a plain object from an IntrustReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.IntrustReq
         * @static
         * @param {Room.IntrustReq} message IntrustReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IntrustReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.action = 0;
            if (message.action != null && message.hasOwnProperty("action"))
                object.action = message.action;
            return object;
        };

        /**
         * Converts this IntrustReq to JSON.
         * @function toJSON
         * @memberof Room.IntrustReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IntrustReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IntrustReq;
    })();

    Room.IntrustRsp = (function() {

        /**
         * Properties of an IntrustRsp.
         * @memberof Room
         * @interface IIntrustRsp
         * @property {number|null} [status] IntrustRsp status
         */

        /**
         * Constructs a new IntrustRsp.
         * @memberof Room
         * @classdesc Represents an IntrustRsp.
         * @implements IIntrustRsp
         * @constructor
         * @param {Room.IIntrustRsp=} [properties] Properties to set
         */
        function IntrustRsp(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IntrustRsp status.
         * @member {number} status
         * @memberof Room.IntrustRsp
         * @instance
         */
        IntrustRsp.prototype.status = 0;

        /**
         * Creates a new IntrustRsp instance using the specified properties.
         * @function create
         * @memberof Room.IntrustRsp
         * @static
         * @param {Room.IIntrustRsp=} [properties] Properties to set
         * @returns {Room.IntrustRsp} IntrustRsp instance
         */
        IntrustRsp.create = function create(properties) {
            return new IntrustRsp(properties);
        };

        /**
         * Encodes the specified IntrustRsp message. Does not implicitly {@link Room.IntrustRsp.verify|verify} messages.
         * @function encode
         * @memberof Room.IntrustRsp
         * @static
         * @param {Room.IIntrustRsp} message IntrustRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntrustRsp.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.status != null && message.hasOwnProperty("status"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified IntrustRsp message, length delimited. Does not implicitly {@link Room.IntrustRsp.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.IntrustRsp
         * @static
         * @param {Room.IIntrustRsp} message IntrustRsp message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntrustRsp.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IntrustRsp message from the specified reader or buffer.
         * @function decode
         * @memberof Room.IntrustRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.IntrustRsp} IntrustRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntrustRsp.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.IntrustRsp();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IntrustRsp message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.IntrustRsp
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.IntrustRsp} IntrustRsp
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntrustRsp.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IntrustRsp message.
         * @function verify
         * @memberof Room.IntrustRsp
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IntrustRsp.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            return null;
        };

        /**
         * Creates an IntrustRsp message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.IntrustRsp
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.IntrustRsp} IntrustRsp
         */
        IntrustRsp.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.IntrustRsp)
                return object;
            var message = new $root.Room.IntrustRsp();
            if (object.status != null)
                message.status = object.status | 0;
            return message;
        };

        /**
         * Creates a plain object from an IntrustRsp message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.IntrustRsp
         * @static
         * @param {Room.IntrustRsp} message IntrustRsp
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IntrustRsp.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.status = 0;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            return object;
        };

        /**
         * Converts this IntrustRsp to JSON.
         * @function toJSON
         * @memberof Room.IntrustRsp
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IntrustRsp.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IntrustRsp;
    })();

    Room.IntrustNotify = (function() {

        /**
         * Properties of an IntrustNotify.
         * @memberof Room
         * @interface IIntrustNotify
         * @property {number|null} [playerId] IntrustNotify playerId
         * @property {number|null} [status] IntrustNotify status
         */

        /**
         * Constructs a new IntrustNotify.
         * @memberof Room
         * @classdesc Represents an IntrustNotify.
         * @implements IIntrustNotify
         * @constructor
         * @param {Room.IIntrustNotify=} [properties] Properties to set
         */
        function IntrustNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * IntrustNotify playerId.
         * @member {number} playerId
         * @memberof Room.IntrustNotify
         * @instance
         */
        IntrustNotify.prototype.playerId = 0;

        /**
         * IntrustNotify status.
         * @member {number} status
         * @memberof Room.IntrustNotify
         * @instance
         */
        IntrustNotify.prototype.status = 0;

        /**
         * Creates a new IntrustNotify instance using the specified properties.
         * @function create
         * @memberof Room.IntrustNotify
         * @static
         * @param {Room.IIntrustNotify=} [properties] Properties to set
         * @returns {Room.IntrustNotify} IntrustNotify instance
         */
        IntrustNotify.create = function create(properties) {
            return new IntrustNotify(properties);
        };

        /**
         * Encodes the specified IntrustNotify message. Does not implicitly {@link Room.IntrustNotify.verify|verify} messages.
         * @function encode
         * @memberof Room.IntrustNotify
         * @static
         * @param {Room.IIntrustNotify} message IntrustNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntrustNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.status != null && message.hasOwnProperty("status"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.status);
            return writer;
        };

        /**
         * Encodes the specified IntrustNotify message, length delimited. Does not implicitly {@link Room.IntrustNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.IntrustNotify
         * @static
         * @param {Room.IIntrustNotify} message IntrustNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        IntrustNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an IntrustNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Room.IntrustNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.IntrustNotify} IntrustNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntrustNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.IntrustNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.status = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an IntrustNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.IntrustNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.IntrustNotify} IntrustNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        IntrustNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an IntrustNotify message.
         * @function verify
         * @memberof Room.IntrustNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        IntrustNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.status != null && message.hasOwnProperty("status"))
                if (!$util.isInteger(message.status))
                    return "status: integer expected";
            return null;
        };

        /**
         * Creates an IntrustNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.IntrustNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.IntrustNotify} IntrustNotify
         */
        IntrustNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.IntrustNotify)
                return object;
            var message = new $root.Room.IntrustNotify();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.status != null)
                message.status = object.status | 0;
            return message;
        };

        /**
         * Creates a plain object from an IntrustNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.IntrustNotify
         * @static
         * @param {Room.IntrustNotify} message IntrustNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        IntrustNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.status = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.status != null && message.hasOwnProperty("status"))
                object.status = message.status;
            return object;
        };

        /**
         * Converts this IntrustNotify to JSON.
         * @function toJSON
         * @memberof Room.IntrustNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        IntrustNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return IntrustNotify;
    })();

    Room.UserCoinBalanceReq = (function() {

        /**
         * Properties of a UserCoinBalanceReq.
         * @memberof Room
         * @interface IUserCoinBalanceReq
         */

        /**
         * Constructs a new UserCoinBalanceReq.
         * @memberof Room
         * @classdesc Represents a UserCoinBalanceReq.
         * @implements IUserCoinBalanceReq
         * @constructor
         * @param {Room.IUserCoinBalanceReq=} [properties] Properties to set
         */
        function UserCoinBalanceReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new UserCoinBalanceReq instance using the specified properties.
         * @function create
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {Room.IUserCoinBalanceReq=} [properties] Properties to set
         * @returns {Room.UserCoinBalanceReq} UserCoinBalanceReq instance
         */
        UserCoinBalanceReq.create = function create(properties) {
            return new UserCoinBalanceReq(properties);
        };

        /**
         * Encodes the specified UserCoinBalanceReq message. Does not implicitly {@link Room.UserCoinBalanceReq.verify|verify} messages.
         * @function encode
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {Room.IUserCoinBalanceReq} message UserCoinBalanceReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserCoinBalanceReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified UserCoinBalanceReq message, length delimited. Does not implicitly {@link Room.UserCoinBalanceReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {Room.IUserCoinBalanceReq} message UserCoinBalanceReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserCoinBalanceReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserCoinBalanceReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.UserCoinBalanceReq} UserCoinBalanceReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserCoinBalanceReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.UserCoinBalanceReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserCoinBalanceReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.UserCoinBalanceReq} UserCoinBalanceReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserCoinBalanceReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserCoinBalanceReq message.
         * @function verify
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserCoinBalanceReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a UserCoinBalanceReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.UserCoinBalanceReq} UserCoinBalanceReq
         */
        UserCoinBalanceReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.UserCoinBalanceReq)
                return object;
            return new $root.Room.UserCoinBalanceReq();
        };

        /**
         * Creates a plain object from a UserCoinBalanceReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.UserCoinBalanceReq
         * @static
         * @param {Room.UserCoinBalanceReq} message UserCoinBalanceReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserCoinBalanceReq.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this UserCoinBalanceReq to JSON.
         * @function toJSON
         * @memberof Room.UserCoinBalanceReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserCoinBalanceReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserCoinBalanceReq;
    })();

    Room.OneShotSettleNotify = (function() {

        /**
         * Properties of an OneShotSettleNotify.
         * @memberof Room
         * @interface IOneShotSettleNotify
         * @property {Array.<Room.OneShotSettleNotify.IPlayer>|null} [players] OneShotSettleNotify players
         */

        /**
         * Constructs a new OneShotSettleNotify.
         * @memberof Room
         * @classdesc Represents an OneShotSettleNotify.
         * @implements IOneShotSettleNotify
         * @constructor
         * @param {Room.IOneShotSettleNotify=} [properties] Properties to set
         */
        function OneShotSettleNotify(properties) {
            this.players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OneShotSettleNotify players.
         * @member {Array.<Room.OneShotSettleNotify.IPlayer>} players
         * @memberof Room.OneShotSettleNotify
         * @instance
         */
        OneShotSettleNotify.prototype.players = $util.emptyArray;

        /**
         * Creates a new OneShotSettleNotify instance using the specified properties.
         * @function create
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {Room.IOneShotSettleNotify=} [properties] Properties to set
         * @returns {Room.OneShotSettleNotify} OneShotSettleNotify instance
         */
        OneShotSettleNotify.create = function create(properties) {
            return new OneShotSettleNotify(properties);
        };

        /**
         * Encodes the specified OneShotSettleNotify message. Does not implicitly {@link Room.OneShotSettleNotify.verify|verify} messages.
         * @function encode
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {Room.IOneShotSettleNotify} message OneShotSettleNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OneShotSettleNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.Room.OneShotSettleNotify.Player.encode(message.players[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified OneShotSettleNotify message, length delimited. Does not implicitly {@link Room.OneShotSettleNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {Room.IOneShotSettleNotify} message OneShotSettleNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OneShotSettleNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OneShotSettleNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.OneShotSettleNotify} OneShotSettleNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OneShotSettleNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.OneShotSettleNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.Room.OneShotSettleNotify.Player.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OneShotSettleNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.OneShotSettleNotify} OneShotSettleNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OneShotSettleNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OneShotSettleNotify message.
         * @function verify
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OneShotSettleNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.Room.OneShotSettleNotify.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            return null;
        };

        /**
         * Creates an OneShotSettleNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.OneShotSettleNotify} OneShotSettleNotify
         */
        OneShotSettleNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.OneShotSettleNotify)
                return object;
            var message = new $root.Room.OneShotSettleNotify();
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".Room.OneShotSettleNotify.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".Room.OneShotSettleNotify.players: object expected");
                    message.players[i] = $root.Room.OneShotSettleNotify.Player.fromObject(object.players[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from an OneShotSettleNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.OneShotSettleNotify
         * @static
         * @param {Room.OneShotSettleNotify} message OneShotSettleNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OneShotSettleNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.players = [];
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.Room.OneShotSettleNotify.Player.toObject(message.players[j], options);
            }
            return object;
        };

        /**
         * Converts this OneShotSettleNotify to JSON.
         * @function toJSON
         * @memberof Room.OneShotSettleNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OneShotSettleNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        OneShotSettleNotify.Player = (function() {

            /**
             * Properties of a Player.
             * @memberof Room.OneShotSettleNotify
             * @interface IPlayer
             * @property {number|null} [playerId] Player playerId
             * @property {number|null} [coin] Player coin
             * @property {number|null} [coinBalance] Player coinBalance
             */

            /**
             * Constructs a new Player.
             * @memberof Room.OneShotSettleNotify
             * @classdesc Represents a Player.
             * @implements IPlayer
             * @constructor
             * @param {Room.OneShotSettleNotify.IPlayer=} [properties] Properties to set
             */
            function Player(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Player playerId.
             * @member {number} playerId
             * @memberof Room.OneShotSettleNotify.Player
             * @instance
             */
            Player.prototype.playerId = 0;

            /**
             * Player coin.
             * @member {number} coin
             * @memberof Room.OneShotSettleNotify.Player
             * @instance
             */
            Player.prototype.coin = 0;

            /**
             * Player coinBalance.
             * @member {number} coinBalance
             * @memberof Room.OneShotSettleNotify.Player
             * @instance
             */
            Player.prototype.coinBalance = 0;

            /**
             * Creates a new Player instance using the specified properties.
             * @function create
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {Room.OneShotSettleNotify.IPlayer=} [properties] Properties to set
             * @returns {Room.OneShotSettleNotify.Player} Player instance
             */
            Player.create = function create(properties) {
                return new Player(properties);
            };

            /**
             * Encodes the specified Player message. Does not implicitly {@link Room.OneShotSettleNotify.Player.verify|verify} messages.
             * @function encode
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {Room.OneShotSettleNotify.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
                if (message.coin != null && message.hasOwnProperty("coin"))
                    writer.uint32(/* id 2, wireType 0 =*/16).int32(message.coin);
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    writer.uint32(/* id 3, wireType 0 =*/24).int32(message.coinBalance);
                return writer;
            };

            /**
             * Encodes the specified Player message, length delimited. Does not implicitly {@link Room.OneShotSettleNotify.Player.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {Room.OneShotSettleNotify.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Player message from the specified reader or buffer.
             * @function decode
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Room.OneShotSettleNotify.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.OneShotSettleNotify.Player();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.playerId = reader.int32();
                        break;
                    case 2:
                        message.coin = reader.int32();
                        break;
                    case 3:
                        message.coinBalance = reader.int32();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Player message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Room.OneShotSettleNotify.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Player message.
             * @function verify
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Player.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.coin != null && message.hasOwnProperty("coin"))
                    if (!$util.isInteger(message.coin))
                        return "coin: integer expected";
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    if (!$util.isInteger(message.coinBalance))
                        return "coinBalance: integer expected";
                return null;
            };

            /**
             * Creates a Player message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Room.OneShotSettleNotify.Player} Player
             */
            Player.fromObject = function fromObject(object) {
                if (object instanceof $root.Room.OneShotSettleNotify.Player)
                    return object;
                var message = new $root.Room.OneShotSettleNotify.Player();
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.coin != null)
                    message.coin = object.coin | 0;
                if (object.coinBalance != null)
                    message.coinBalance = object.coinBalance | 0;
                return message;
            };

            /**
             * Creates a plain object from a Player message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Room.OneShotSettleNotify.Player
             * @static
             * @param {Room.OneShotSettleNotify.Player} message Player
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Player.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.playerId = 0;
                    object.coin = 0;
                    object.coinBalance = 0;
                }
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.coin != null && message.hasOwnProperty("coin"))
                    object.coin = message.coin;
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    object.coinBalance = message.coinBalance;
                return object;
            };

            /**
             * Converts this Player to JSON.
             * @function toJSON
             * @memberof Room.OneShotSettleNotify.Player
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Player.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Player;
        })();

        return OneShotSettleNotify;
    })();

    Room.RechargeReq = (function() {

        /**
         * Properties of a RechargeReq.
         * @memberof Room
         * @interface IRechargeReq
         * @property {boolean|null} [open] RechargeReq open
         */

        /**
         * Constructs a new RechargeReq.
         * @memberof Room
         * @classdesc Represents a RechargeReq.
         * @implements IRechargeReq
         * @constructor
         * @param {Room.IRechargeReq=} [properties] Properties to set
         */
        function RechargeReq(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RechargeReq open.
         * @member {boolean} open
         * @memberof Room.RechargeReq
         * @instance
         */
        RechargeReq.prototype.open = false;

        /**
         * Creates a new RechargeReq instance using the specified properties.
         * @function create
         * @memberof Room.RechargeReq
         * @static
         * @param {Room.IRechargeReq=} [properties] Properties to set
         * @returns {Room.RechargeReq} RechargeReq instance
         */
        RechargeReq.create = function create(properties) {
            return new RechargeReq(properties);
        };

        /**
         * Encodes the specified RechargeReq message. Does not implicitly {@link Room.RechargeReq.verify|verify} messages.
         * @function encode
         * @memberof Room.RechargeReq
         * @static
         * @param {Room.IRechargeReq} message RechargeReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeReq.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.open != null && message.hasOwnProperty("open"))
                writer.uint32(/* id 1, wireType 0 =*/8).bool(message.open);
            return writer;
        };

        /**
         * Encodes the specified RechargeReq message, length delimited. Does not implicitly {@link Room.RechargeReq.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.RechargeReq
         * @static
         * @param {Room.IRechargeReq} message RechargeReq message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeReq.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RechargeReq message from the specified reader or buffer.
         * @function decode
         * @memberof Room.RechargeReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.RechargeReq} RechargeReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeReq.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.RechargeReq();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.open = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RechargeReq message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.RechargeReq
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.RechargeReq} RechargeReq
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeReq.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RechargeReq message.
         * @function verify
         * @memberof Room.RechargeReq
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RechargeReq.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.open != null && message.hasOwnProperty("open"))
                if (typeof message.open !== "boolean")
                    return "open: boolean expected";
            return null;
        };

        /**
         * Creates a RechargeReq message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.RechargeReq
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.RechargeReq} RechargeReq
         */
        RechargeReq.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.RechargeReq)
                return object;
            var message = new $root.Room.RechargeReq();
            if (object.open != null)
                message.open = Boolean(object.open);
            return message;
        };

        /**
         * Creates a plain object from a RechargeReq message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.RechargeReq
         * @static
         * @param {Room.RechargeReq} message RechargeReq
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RechargeReq.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.open = false;
            if (message.open != null && message.hasOwnProperty("open"))
                object.open = message.open;
            return object;
        };

        /**
         * Converts this RechargeReq to JSON.
         * @function toJSON
         * @memberof Room.RechargeReq
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RechargeReq.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RechargeReq;
    })();

    Room.RechargeNotify = (function() {

        /**
         * Properties of a RechargeNotify.
         * @memberof Room
         * @interface IRechargeNotify
         * @property {number|null} [playerid] RechargeNotify playerid
         * @property {boolean|null} [open] RechargeNotify open
         * @property {number|null} [time] RechargeNotify time
         */

        /**
         * Constructs a new RechargeNotify.
         * @memberof Room
         * @classdesc Represents a RechargeNotify.
         * @implements IRechargeNotify
         * @constructor
         * @param {Room.IRechargeNotify=} [properties] Properties to set
         */
        function RechargeNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RechargeNotify playerid.
         * @member {number} playerid
         * @memberof Room.RechargeNotify
         * @instance
         */
        RechargeNotify.prototype.playerid = 0;

        /**
         * RechargeNotify open.
         * @member {boolean} open
         * @memberof Room.RechargeNotify
         * @instance
         */
        RechargeNotify.prototype.open = false;

        /**
         * RechargeNotify time.
         * @member {number} time
         * @memberof Room.RechargeNotify
         * @instance
         */
        RechargeNotify.prototype.time = 0;

        /**
         * Creates a new RechargeNotify instance using the specified properties.
         * @function create
         * @memberof Room.RechargeNotify
         * @static
         * @param {Room.IRechargeNotify=} [properties] Properties to set
         * @returns {Room.RechargeNotify} RechargeNotify instance
         */
        RechargeNotify.create = function create(properties) {
            return new RechargeNotify(properties);
        };

        /**
         * Encodes the specified RechargeNotify message. Does not implicitly {@link Room.RechargeNotify.verify|verify} messages.
         * @function encode
         * @memberof Room.RechargeNotify
         * @static
         * @param {Room.IRechargeNotify} message RechargeNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerid != null && message.hasOwnProperty("playerid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerid);
            if (message.open != null && message.hasOwnProperty("open"))
                writer.uint32(/* id 2, wireType 0 =*/16).bool(message.open);
            if (message.time != null && message.hasOwnProperty("time"))
                writer.uint32(/* id 3, wireType 0 =*/24).int32(message.time);
            return writer;
        };

        /**
         * Encodes the specified RechargeNotify message, length delimited. Does not implicitly {@link Room.RechargeNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.RechargeNotify
         * @static
         * @param {Room.IRechargeNotify} message RechargeNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RechargeNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a RechargeNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Room.RechargeNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.RechargeNotify} RechargeNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.RechargeNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerid = reader.int32();
                    break;
                case 2:
                    message.open = reader.bool();
                    break;
                case 3:
                    message.time = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a RechargeNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.RechargeNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.RechargeNotify} RechargeNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RechargeNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a RechargeNotify message.
         * @function verify
         * @memberof Room.RechargeNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        RechargeNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerid != null && message.hasOwnProperty("playerid"))
                if (!$util.isInteger(message.playerid))
                    return "playerid: integer expected";
            if (message.open != null && message.hasOwnProperty("open"))
                if (typeof message.open !== "boolean")
                    return "open: boolean expected";
            if (message.time != null && message.hasOwnProperty("time"))
                if (!$util.isInteger(message.time))
                    return "time: integer expected";
            return null;
        };

        /**
         * Creates a RechargeNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.RechargeNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.RechargeNotify} RechargeNotify
         */
        RechargeNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.RechargeNotify)
                return object;
            var message = new $root.Room.RechargeNotify();
            if (object.playerid != null)
                message.playerid = object.playerid | 0;
            if (object.open != null)
                message.open = Boolean(object.open);
            if (object.time != null)
                message.time = object.time | 0;
            return message;
        };

        /**
         * Creates a plain object from a RechargeNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.RechargeNotify
         * @static
         * @param {Room.RechargeNotify} message RechargeNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RechargeNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerid = 0;
                object.open = false;
                object.time = 0;
            }
            if (message.playerid != null && message.hasOwnProperty("playerid"))
                object.playerid = message.playerid;
            if (message.open != null && message.hasOwnProperty("open"))
                object.open = message.open;
            if (message.time != null && message.hasOwnProperty("time"))
                object.time = message.time;
            return object;
        };

        /**
         * Converts this RechargeNotify to JSON.
         * @function toJSON
         * @memberof Room.RechargeNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        RechargeNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RechargeNotify;
    })();

    Room.EnterBroadcast = (function() {

        /**
         * Properties of an EnterBroadcast.
         * @memberof Room
         * @interface IEnterBroadcast
         * @property {Room.IPosInfo|null} [posInfo] EnterBroadcast posInfo
         * @property {string|null} [userJson] EnterBroadcast userJson
         */

        /**
         * Constructs a new EnterBroadcast.
         * @memberof Room
         * @classdesc Represents an EnterBroadcast.
         * @implements IEnterBroadcast
         * @constructor
         * @param {Room.IEnterBroadcast=} [properties] Properties to set
         */
        function EnterBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * EnterBroadcast posInfo.
         * @member {Room.IPosInfo|null|undefined} posInfo
         * @memberof Room.EnterBroadcast
         * @instance
         */
        EnterBroadcast.prototype.posInfo = null;

        /**
         * EnterBroadcast userJson.
         * @member {string} userJson
         * @memberof Room.EnterBroadcast
         * @instance
         */
        EnterBroadcast.prototype.userJson = "";

        /**
         * Creates a new EnterBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.EnterBroadcast
         * @static
         * @param {Room.IEnterBroadcast=} [properties] Properties to set
         * @returns {Room.EnterBroadcast} EnterBroadcast instance
         */
        EnterBroadcast.create = function create(properties) {
            return new EnterBroadcast(properties);
        };

        /**
         * Encodes the specified EnterBroadcast message. Does not implicitly {@link Room.EnterBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.EnterBroadcast
         * @static
         * @param {Room.IEnterBroadcast} message EnterBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnterBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.posInfo != null && message.hasOwnProperty("posInfo"))
                $root.Room.PosInfo.encode(message.posInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                writer.uint32(/* id 13, wireType 2 =*/106).string(message.userJson);
            return writer;
        };

        /**
         * Encodes the specified EnterBroadcast message, length delimited. Does not implicitly {@link Room.EnterBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.EnterBroadcast
         * @static
         * @param {Room.IEnterBroadcast} message EnterBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        EnterBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an EnterBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.EnterBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.EnterBroadcast} EnterBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnterBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.EnterBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.posInfo = $root.Room.PosInfo.decode(reader, reader.uint32());
                    break;
                case 13:
                    message.userJson = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an EnterBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.EnterBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.EnterBroadcast} EnterBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        EnterBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an EnterBroadcast message.
         * @function verify
         * @memberof Room.EnterBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        EnterBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.posInfo != null && message.hasOwnProperty("posInfo")) {
                var error = $root.Room.PosInfo.verify(message.posInfo);
                if (error)
                    return "posInfo." + error;
            }
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                if (!$util.isString(message.userJson))
                    return "userJson: string expected";
            return null;
        };

        /**
         * Creates an EnterBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.EnterBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.EnterBroadcast} EnterBroadcast
         */
        EnterBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.EnterBroadcast)
                return object;
            var message = new $root.Room.EnterBroadcast();
            if (object.posInfo != null) {
                if (typeof object.posInfo !== "object")
                    throw TypeError(".Room.EnterBroadcast.posInfo: object expected");
                message.posInfo = $root.Room.PosInfo.fromObject(object.posInfo);
            }
            if (object.userJson != null)
                message.userJson = String(object.userJson);
            return message;
        };

        /**
         * Creates a plain object from an EnterBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.EnterBroadcast
         * @static
         * @param {Room.EnterBroadcast} message EnterBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        EnterBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.posInfo = null;
                object.userJson = "";
            }
            if (message.posInfo != null && message.hasOwnProperty("posInfo"))
                object.posInfo = $root.Room.PosInfo.toObject(message.posInfo, options);
            if (message.userJson != null && message.hasOwnProperty("userJson"))
                object.userJson = message.userJson;
            return object;
        };

        /**
         * Converts this EnterBroadcast to JSON.
         * @function toJSON
         * @memberof Room.EnterBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        EnterBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return EnterBroadcast;
    })();

    Room.ReadyBroadcast = (function() {

        /**
         * Properties of a ReadyBroadcast.
         * @memberof Room
         * @interface IReadyBroadcast
         * @property {Room.IPosInfo|null} [posInfo] ReadyBroadcast posInfo
         */

        /**
         * Constructs a new ReadyBroadcast.
         * @memberof Room
         * @classdesc Represents a ReadyBroadcast.
         * @implements IReadyBroadcast
         * @constructor
         * @param {Room.IReadyBroadcast=} [properties] Properties to set
         */
        function ReadyBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReadyBroadcast posInfo.
         * @member {Room.IPosInfo|null|undefined} posInfo
         * @memberof Room.ReadyBroadcast
         * @instance
         */
        ReadyBroadcast.prototype.posInfo = null;

        /**
         * Creates a new ReadyBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {Room.IReadyBroadcast=} [properties] Properties to set
         * @returns {Room.ReadyBroadcast} ReadyBroadcast instance
         */
        ReadyBroadcast.create = function create(properties) {
            return new ReadyBroadcast(properties);
        };

        /**
         * Encodes the specified ReadyBroadcast message. Does not implicitly {@link Room.ReadyBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {Room.IReadyBroadcast} message ReadyBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadyBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.posInfo != null && message.hasOwnProperty("posInfo"))
                $root.Room.PosInfo.encode(message.posInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ReadyBroadcast message, length delimited. Does not implicitly {@link Room.ReadyBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {Room.IReadyBroadcast} message ReadyBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReadyBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReadyBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ReadyBroadcast} ReadyBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadyBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ReadyBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.posInfo = $root.Room.PosInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReadyBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ReadyBroadcast} ReadyBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReadyBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReadyBroadcast message.
         * @function verify
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReadyBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.posInfo != null && message.hasOwnProperty("posInfo")) {
                var error = $root.Room.PosInfo.verify(message.posInfo);
                if (error)
                    return "posInfo." + error;
            }
            return null;
        };

        /**
         * Creates a ReadyBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ReadyBroadcast} ReadyBroadcast
         */
        ReadyBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ReadyBroadcast)
                return object;
            var message = new $root.Room.ReadyBroadcast();
            if (object.posInfo != null) {
                if (typeof object.posInfo !== "object")
                    throw TypeError(".Room.ReadyBroadcast.posInfo: object expected");
                message.posInfo = $root.Room.PosInfo.fromObject(object.posInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a ReadyBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ReadyBroadcast
         * @static
         * @param {Room.ReadyBroadcast} message ReadyBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReadyBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.posInfo = null;
            if (message.posInfo != null && message.hasOwnProperty("posInfo"))
                object.posInfo = $root.Room.PosInfo.toObject(message.posInfo, options);
            return object;
        };

        /**
         * Converts this ReadyBroadcast to JSON.
         * @function toJSON
         * @memberof Room.ReadyBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReadyBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReadyBroadcast;
    })();

    Room.StartBroadcast = (function() {

        /**
         * Properties of a StartBroadcast.
         * @memberof Room
         * @interface IStartBroadcast
         * @property {string|null} [errNo] StartBroadcast errNo
         */

        /**
         * Constructs a new StartBroadcast.
         * @memberof Room
         * @classdesc Represents a StartBroadcast.
         * @implements IStartBroadcast
         * @constructor
         * @param {Room.IStartBroadcast=} [properties] Properties to set
         */
        function StartBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * StartBroadcast errNo.
         * @member {string} errNo
         * @memberof Room.StartBroadcast
         * @instance
         */
        StartBroadcast.prototype.errNo = "";

        /**
         * Creates a new StartBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.StartBroadcast
         * @static
         * @param {Room.IStartBroadcast=} [properties] Properties to set
         * @returns {Room.StartBroadcast} StartBroadcast instance
         */
        StartBroadcast.create = function create(properties) {
            return new StartBroadcast(properties);
        };

        /**
         * Encodes the specified StartBroadcast message. Does not implicitly {@link Room.StartBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.StartBroadcast
         * @static
         * @param {Room.IStartBroadcast} message StartBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified StartBroadcast message, length delimited. Does not implicitly {@link Room.StartBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.StartBroadcast
         * @static
         * @param {Room.IStartBroadcast} message StartBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        StartBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a StartBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.StartBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.StartBroadcast} StartBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.StartBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a StartBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.StartBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.StartBroadcast} StartBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        StartBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a StartBroadcast message.
         * @function verify
         * @memberof Room.StartBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        StartBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a StartBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.StartBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.StartBroadcast} StartBroadcast
         */
        StartBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.StartBroadcast)
                return object;
            var message = new $root.Room.StartBroadcast();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a StartBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.StartBroadcast
         * @static
         * @param {Room.StartBroadcast} message StartBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        StartBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this StartBroadcast to JSON.
         * @function toJSON
         * @memberof Room.StartBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        StartBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return StartBroadcast;
    })();

    Room.ResetBroadcast = (function() {

        /**
         * Properties of a ResetBroadcast.
         * @memberof Room
         * @interface IResetBroadcast
         * @property {Array.<Room.IPosInfo>|null} [posInfos] ResetBroadcast posInfos
         */

        /**
         * Constructs a new ResetBroadcast.
         * @memberof Room
         * @classdesc Represents a ResetBroadcast.
         * @implements IResetBroadcast
         * @constructor
         * @param {Room.IResetBroadcast=} [properties] Properties to set
         */
        function ResetBroadcast(properties) {
            this.posInfos = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResetBroadcast posInfos.
         * @member {Array.<Room.IPosInfo>} posInfos
         * @memberof Room.ResetBroadcast
         * @instance
         */
        ResetBroadcast.prototype.posInfos = $util.emptyArray;

        /**
         * Creates a new ResetBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.ResetBroadcast
         * @static
         * @param {Room.IResetBroadcast=} [properties] Properties to set
         * @returns {Room.ResetBroadcast} ResetBroadcast instance
         */
        ResetBroadcast.create = function create(properties) {
            return new ResetBroadcast(properties);
        };

        /**
         * Encodes the specified ResetBroadcast message. Does not implicitly {@link Room.ResetBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.ResetBroadcast
         * @static
         * @param {Room.IResetBroadcast} message ResetBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.posInfos != null && message.posInfos.length)
                for (var i = 0; i < message.posInfos.length; ++i)
                    $root.Room.PosInfo.encode(message.posInfos[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ResetBroadcast message, length delimited. Does not implicitly {@link Room.ResetBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ResetBroadcast
         * @static
         * @param {Room.IResetBroadcast} message ResetBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResetBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ResetBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ResetBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ResetBroadcast} ResetBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ResetBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.posInfos && message.posInfos.length))
                        message.posInfos = [];
                    message.posInfos.push($root.Room.PosInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ResetBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ResetBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ResetBroadcast} ResetBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResetBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ResetBroadcast message.
         * @function verify
         * @memberof Room.ResetBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ResetBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.posInfos != null && message.hasOwnProperty("posInfos")) {
                if (!Array.isArray(message.posInfos))
                    return "posInfos: array expected";
                for (var i = 0; i < message.posInfos.length; ++i) {
                    var error = $root.Room.PosInfo.verify(message.posInfos[i]);
                    if (error)
                        return "posInfos." + error;
                }
            }
            return null;
        };

        /**
         * Creates a ResetBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ResetBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ResetBroadcast} ResetBroadcast
         */
        ResetBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ResetBroadcast)
                return object;
            var message = new $root.Room.ResetBroadcast();
            if (object.posInfos) {
                if (!Array.isArray(object.posInfos))
                    throw TypeError(".Room.ResetBroadcast.posInfos: array expected");
                message.posInfos = [];
                for (var i = 0; i < object.posInfos.length; ++i) {
                    if (typeof object.posInfos[i] !== "object")
                        throw TypeError(".Room.ResetBroadcast.posInfos: object expected");
                    message.posInfos[i] = $root.Room.PosInfo.fromObject(object.posInfos[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a ResetBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ResetBroadcast
         * @static
         * @param {Room.ResetBroadcast} message ResetBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResetBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.posInfos = [];
            if (message.posInfos && message.posInfos.length) {
                object.posInfos = [];
                for (var j = 0; j < message.posInfos.length; ++j)
                    object.posInfos[j] = $root.Room.PosInfo.toObject(message.posInfos[j], options);
            }
            return object;
        };

        /**
         * Converts this ResetBroadcast to JSON.
         * @function toJSON
         * @memberof Room.ResetBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ResetBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResetBroadcast;
    })();

    Room.SynchronizeBroadcast = (function() {

        /**
         * Properties of a SynchronizeBroadcast.
         * @memberof Room
         * @interface ISynchronizeBroadcast
         * @property {Room.IRoomInfo|null} [roomInfo] SynchronizeBroadcast roomInfo
         */

        /**
         * Constructs a new SynchronizeBroadcast.
         * @memberof Room
         * @classdesc Represents a SynchronizeBroadcast.
         * @implements ISynchronizeBroadcast
         * @constructor
         * @param {Room.ISynchronizeBroadcast=} [properties] Properties to set
         */
        function SynchronizeBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SynchronizeBroadcast roomInfo.
         * @member {Room.IRoomInfo|null|undefined} roomInfo
         * @memberof Room.SynchronizeBroadcast
         * @instance
         */
        SynchronizeBroadcast.prototype.roomInfo = null;

        /**
         * Creates a new SynchronizeBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {Room.ISynchronizeBroadcast=} [properties] Properties to set
         * @returns {Room.SynchronizeBroadcast} SynchronizeBroadcast instance
         */
        SynchronizeBroadcast.create = function create(properties) {
            return new SynchronizeBroadcast(properties);
        };

        /**
         * Encodes the specified SynchronizeBroadcast message. Does not implicitly {@link Room.SynchronizeBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {Room.ISynchronizeBroadcast} message SynchronizeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SynchronizeBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.roomInfo != null && message.hasOwnProperty("roomInfo"))
                $root.Room.RoomInfo.encode(message.roomInfo, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SynchronizeBroadcast message, length delimited. Does not implicitly {@link Room.SynchronizeBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {Room.ISynchronizeBroadcast} message SynchronizeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SynchronizeBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SynchronizeBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.SynchronizeBroadcast} SynchronizeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SynchronizeBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.SynchronizeBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.roomInfo = $root.Room.RoomInfo.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SynchronizeBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.SynchronizeBroadcast} SynchronizeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SynchronizeBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SynchronizeBroadcast message.
         * @function verify
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SynchronizeBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.roomInfo != null && message.hasOwnProperty("roomInfo")) {
                var error = $root.Room.RoomInfo.verify(message.roomInfo);
                if (error)
                    return "roomInfo." + error;
            }
            return null;
        };

        /**
         * Creates a SynchronizeBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.SynchronizeBroadcast} SynchronizeBroadcast
         */
        SynchronizeBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.SynchronizeBroadcast)
                return object;
            var message = new $root.Room.SynchronizeBroadcast();
            if (object.roomInfo != null) {
                if (typeof object.roomInfo !== "object")
                    throw TypeError(".Room.SynchronizeBroadcast.roomInfo: object expected");
                message.roomInfo = $root.Room.RoomInfo.fromObject(object.roomInfo);
            }
            return message;
        };

        /**
         * Creates a plain object from a SynchronizeBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.SynchronizeBroadcast
         * @static
         * @param {Room.SynchronizeBroadcast} message SynchronizeBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SynchronizeBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.roomInfo = null;
            if (message.roomInfo != null && message.hasOwnProperty("roomInfo"))
                object.roomInfo = $root.Room.RoomInfo.toObject(message.roomInfo, options);
            return object;
        };

        /**
         * Converts this SynchronizeBroadcast to JSON.
         * @function toJSON
         * @memberof Room.SynchronizeBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SynchronizeBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SynchronizeBroadcast;
    })();

    Room.SynExpireBroadcast = (function() {

        /**
         * Properties of a SynExpireBroadcast.
         * @memberof Room
         * @interface ISynExpireBroadcast
         * @property {Array.<Room.IExpiresInfo>|null} [expires] SynExpireBroadcast expires
         */

        /**
         * Constructs a new SynExpireBroadcast.
         * @memberof Room
         * @classdesc Represents a SynExpireBroadcast.
         * @implements ISynExpireBroadcast
         * @constructor
         * @param {Room.ISynExpireBroadcast=} [properties] Properties to set
         */
        function SynExpireBroadcast(properties) {
            this.expires = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SynExpireBroadcast expires.
         * @member {Array.<Room.IExpiresInfo>} expires
         * @memberof Room.SynExpireBroadcast
         * @instance
         */
        SynExpireBroadcast.prototype.expires = $util.emptyArray;

        /**
         * Creates a new SynExpireBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {Room.ISynExpireBroadcast=} [properties] Properties to set
         * @returns {Room.SynExpireBroadcast} SynExpireBroadcast instance
         */
        SynExpireBroadcast.create = function create(properties) {
            return new SynExpireBroadcast(properties);
        };

        /**
         * Encodes the specified SynExpireBroadcast message. Does not implicitly {@link Room.SynExpireBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {Room.ISynExpireBroadcast} message SynExpireBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SynExpireBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.expires != null && message.expires.length)
                for (var i = 0; i < message.expires.length; ++i)
                    $root.Room.ExpiresInfo.encode(message.expires[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified SynExpireBroadcast message, length delimited. Does not implicitly {@link Room.SynExpireBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {Room.ISynExpireBroadcast} message SynExpireBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SynExpireBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a SynExpireBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.SynExpireBroadcast} SynExpireBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SynExpireBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.SynExpireBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.expires && message.expires.length))
                        message.expires = [];
                    message.expires.push($root.Room.ExpiresInfo.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a SynExpireBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.SynExpireBroadcast} SynExpireBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SynExpireBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a SynExpireBroadcast message.
         * @function verify
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        SynExpireBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.expires != null && message.hasOwnProperty("expires")) {
                if (!Array.isArray(message.expires))
                    return "expires: array expected";
                for (var i = 0; i < message.expires.length; ++i) {
                    var error = $root.Room.ExpiresInfo.verify(message.expires[i]);
                    if (error)
                        return "expires." + error;
                }
            }
            return null;
        };

        /**
         * Creates a SynExpireBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.SynExpireBroadcast} SynExpireBroadcast
         */
        SynExpireBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.SynExpireBroadcast)
                return object;
            var message = new $root.Room.SynExpireBroadcast();
            if (object.expires) {
                if (!Array.isArray(object.expires))
                    throw TypeError(".Room.SynExpireBroadcast.expires: array expected");
                message.expires = [];
                for (var i = 0; i < object.expires.length; ++i) {
                    if (typeof object.expires[i] !== "object")
                        throw TypeError(".Room.SynExpireBroadcast.expires: object expected");
                    message.expires[i] = $root.Room.ExpiresInfo.fromObject(object.expires[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a SynExpireBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.SynExpireBroadcast
         * @static
         * @param {Room.SynExpireBroadcast} message SynExpireBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SynExpireBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.expires = [];
            if (message.expires && message.expires.length) {
                object.expires = [];
                for (var j = 0; j < message.expires.length; ++j)
                    object.expires[j] = $root.Room.ExpiresInfo.toObject(message.expires[j], options);
            }
            return object;
        };

        /**
         * Converts this SynExpireBroadcast to JSON.
         * @function toJSON
         * @memberof Room.SynExpireBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        SynExpireBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SynExpireBroadcast;
    })();

    Room.ReconnBroadcast = (function() {

        /**
         * Properties of a ReconnBroadcast.
         * @memberof Room
         * @interface IReconnBroadcast
         * @property {number|null} [playerId] ReconnBroadcast playerId
         */

        /**
         * Constructs a new ReconnBroadcast.
         * @memberof Room
         * @classdesc Represents a ReconnBroadcast.
         * @implements IReconnBroadcast
         * @constructor
         * @param {Room.IReconnBroadcast=} [properties] Properties to set
         */
        function ReconnBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReconnBroadcast playerId.
         * @member {number} playerId
         * @memberof Room.ReconnBroadcast
         * @instance
         */
        ReconnBroadcast.prototype.playerId = 0;

        /**
         * Creates a new ReconnBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {Room.IReconnBroadcast=} [properties] Properties to set
         * @returns {Room.ReconnBroadcast} ReconnBroadcast instance
         */
        ReconnBroadcast.create = function create(properties) {
            return new ReconnBroadcast(properties);
        };

        /**
         * Encodes the specified ReconnBroadcast message. Does not implicitly {@link Room.ReconnBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {Room.IReconnBroadcast} message ReconnBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReconnBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified ReconnBroadcast message, length delimited. Does not implicitly {@link Room.ReconnBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {Room.IReconnBroadcast} message ReconnBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReconnBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ReconnBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ReconnBroadcast} ReconnBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReconnBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ReconnBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ReconnBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ReconnBroadcast} ReconnBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReconnBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ReconnBroadcast message.
         * @function verify
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ReconnBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a ReconnBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ReconnBroadcast} ReconnBroadcast
         */
        ReconnBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ReconnBroadcast)
                return object;
            var message = new $root.Room.ReconnBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a ReconnBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ReconnBroadcast
         * @static
         * @param {Room.ReconnBroadcast} message ReconnBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReconnBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this ReconnBroadcast to JSON.
         * @function toJSON
         * @memberof Room.ReconnBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ReconnBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReconnBroadcast;
    })();

    Room.DisconnBroadcast = (function() {

        /**
         * Properties of a DisconnBroadcast.
         * @memberof Room
         * @interface IDisconnBroadcast
         * @property {number|null} [playerId] DisconnBroadcast playerId
         */

        /**
         * Constructs a new DisconnBroadcast.
         * @memberof Room
         * @classdesc Represents a DisconnBroadcast.
         * @implements IDisconnBroadcast
         * @constructor
         * @param {Room.IDisconnBroadcast=} [properties] Properties to set
         */
        function DisconnBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * DisconnBroadcast playerId.
         * @member {number} playerId
         * @memberof Room.DisconnBroadcast
         * @instance
         */
        DisconnBroadcast.prototype.playerId = 0;

        /**
         * Creates a new DisconnBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {Room.IDisconnBroadcast=} [properties] Properties to set
         * @returns {Room.DisconnBroadcast} DisconnBroadcast instance
         */
        DisconnBroadcast.create = function create(properties) {
            return new DisconnBroadcast(properties);
        };

        /**
         * Encodes the specified DisconnBroadcast message. Does not implicitly {@link Room.DisconnBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {Room.IDisconnBroadcast} message DisconnBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DisconnBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified DisconnBroadcast message, length delimited. Does not implicitly {@link Room.DisconnBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {Room.IDisconnBroadcast} message DisconnBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DisconnBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a DisconnBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.DisconnBroadcast} DisconnBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DisconnBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.DisconnBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a DisconnBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.DisconnBroadcast} DisconnBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DisconnBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a DisconnBroadcast message.
         * @function verify
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        DisconnBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a DisconnBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.DisconnBroadcast} DisconnBroadcast
         */
        DisconnBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.DisconnBroadcast)
                return object;
            var message = new $root.Room.DisconnBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a DisconnBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.DisconnBroadcast
         * @static
         * @param {Room.DisconnBroadcast} message DisconnBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DisconnBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this DisconnBroadcast to JSON.
         * @function toJSON
         * @memberof Room.DisconnBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        DisconnBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DisconnBroadcast;
    })();

    Room.CreateBroadcast = (function() {

        /**
         * Properties of a CreateBroadcast.
         * @memberof Room
         * @interface ICreateBroadcast
         * @property {string|null} [errNo] CreateBroadcast errNo
         */

        /**
         * Constructs a new CreateBroadcast.
         * @memberof Room
         * @classdesc Represents a CreateBroadcast.
         * @implements ICreateBroadcast
         * @constructor
         * @param {Room.ICreateBroadcast=} [properties] Properties to set
         */
        function CreateBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CreateBroadcast errNo.
         * @member {string} errNo
         * @memberof Room.CreateBroadcast
         * @instance
         */
        CreateBroadcast.prototype.errNo = "";

        /**
         * Creates a new CreateBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.CreateBroadcast
         * @static
         * @param {Room.ICreateBroadcast=} [properties] Properties to set
         * @returns {Room.CreateBroadcast} CreateBroadcast instance
         */
        CreateBroadcast.create = function create(properties) {
            return new CreateBroadcast(properties);
        };

        /**
         * Encodes the specified CreateBroadcast message. Does not implicitly {@link Room.CreateBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.CreateBroadcast
         * @static
         * @param {Room.ICreateBroadcast} message CreateBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.errNo);
            return writer;
        };

        /**
         * Encodes the specified CreateBroadcast message, length delimited. Does not implicitly {@link Room.CreateBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CreateBroadcast
         * @static
         * @param {Room.ICreateBroadcast} message CreateBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CreateBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CreateBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CreateBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CreateBroadcast} CreateBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CreateBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.errNo = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CreateBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CreateBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CreateBroadcast} CreateBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CreateBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CreateBroadcast message.
         * @function verify
         * @memberof Room.CreateBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CreateBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                if (!$util.isString(message.errNo))
                    return "errNo: string expected";
            return null;
        };

        /**
         * Creates a CreateBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CreateBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CreateBroadcast} CreateBroadcast
         */
        CreateBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CreateBroadcast)
                return object;
            var message = new $root.Room.CreateBroadcast();
            if (object.errNo != null)
                message.errNo = String(object.errNo);
            return message;
        };

        /**
         * Creates a plain object from a CreateBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CreateBroadcast
         * @static
         * @param {Room.CreateBroadcast} message CreateBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CreateBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.errNo = "";
            if (message.errNo != null && message.hasOwnProperty("errNo"))
                object.errNo = message.errNo;
            return object;
        };

        /**
         * Converts this CreateBroadcast to JSON.
         * @function toJSON
         * @memberof Room.CreateBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CreateBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CreateBroadcast;
    })();

    Room.FreeBroadcast = (function() {

        /**
         * Properties of a FreeBroadcast.
         * @memberof Room
         * @interface IFreeBroadcast
         * @property {Array.<Room.IFreeRoomState>|null} [freeRoomStateList] FreeBroadcast freeRoomStateList
         * @property {number|null} [expire] FreeBroadcast expire
         */

        /**
         * Constructs a new FreeBroadcast.
         * @memberof Room
         * @classdesc Represents a FreeBroadcast.
         * @implements IFreeBroadcast
         * @constructor
         * @param {Room.IFreeBroadcast=} [properties] Properties to set
         */
        function FreeBroadcast(properties) {
            this.freeRoomStateList = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * FreeBroadcast freeRoomStateList.
         * @member {Array.<Room.IFreeRoomState>} freeRoomStateList
         * @memberof Room.FreeBroadcast
         * @instance
         */
        FreeBroadcast.prototype.freeRoomStateList = $util.emptyArray;

        /**
         * FreeBroadcast expire.
         * @member {number} expire
         * @memberof Room.FreeBroadcast
         * @instance
         */
        FreeBroadcast.prototype.expire = 0;

        /**
         * Creates a new FreeBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.FreeBroadcast
         * @static
         * @param {Room.IFreeBroadcast=} [properties] Properties to set
         * @returns {Room.FreeBroadcast} FreeBroadcast instance
         */
        FreeBroadcast.create = function create(properties) {
            return new FreeBroadcast(properties);
        };

        /**
         * Encodes the specified FreeBroadcast message. Does not implicitly {@link Room.FreeBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.FreeBroadcast
         * @static
         * @param {Room.IFreeBroadcast} message FreeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.freeRoomStateList != null && message.freeRoomStateList.length)
                for (var i = 0; i < message.freeRoomStateList.length; ++i)
                    $root.Room.FreeRoomState.encode(message.freeRoomStateList[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.expire != null && message.hasOwnProperty("expire"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.expire);
            return writer;
        };

        /**
         * Encodes the specified FreeBroadcast message, length delimited. Does not implicitly {@link Room.FreeBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.FreeBroadcast
         * @static
         * @param {Room.IFreeBroadcast} message FreeBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FreeBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.FreeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.FreeBroadcast} FreeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.FreeBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.freeRoomStateList && message.freeRoomStateList.length))
                        message.freeRoomStateList = [];
                    message.freeRoomStateList.push($root.Room.FreeRoomState.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.expire = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FreeBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.FreeBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.FreeBroadcast} FreeBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FreeBroadcast message.
         * @function verify
         * @memberof Room.FreeBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FreeBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.freeRoomStateList != null && message.hasOwnProperty("freeRoomStateList")) {
                if (!Array.isArray(message.freeRoomStateList))
                    return "freeRoomStateList: array expected";
                for (var i = 0; i < message.freeRoomStateList.length; ++i) {
                    var error = $root.Room.FreeRoomState.verify(message.freeRoomStateList[i]);
                    if (error)
                        return "freeRoomStateList." + error;
                }
            }
            if (message.expire != null && message.hasOwnProperty("expire"))
                if (!$util.isInteger(message.expire))
                    return "expire: integer expected";
            return null;
        };

        /**
         * Creates a FreeBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.FreeBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.FreeBroadcast} FreeBroadcast
         */
        FreeBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.FreeBroadcast)
                return object;
            var message = new $root.Room.FreeBroadcast();
            if (object.freeRoomStateList) {
                if (!Array.isArray(object.freeRoomStateList))
                    throw TypeError(".Room.FreeBroadcast.freeRoomStateList: array expected");
                message.freeRoomStateList = [];
                for (var i = 0; i < object.freeRoomStateList.length; ++i) {
                    if (typeof object.freeRoomStateList[i] !== "object")
                        throw TypeError(".Room.FreeBroadcast.freeRoomStateList: object expected");
                    message.freeRoomStateList[i] = $root.Room.FreeRoomState.fromObject(object.freeRoomStateList[i]);
                }
            }
            if (object.expire != null)
                message.expire = object.expire | 0;
            return message;
        };

        /**
         * Creates a plain object from a FreeBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.FreeBroadcast
         * @static
         * @param {Room.FreeBroadcast} message FreeBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FreeBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.freeRoomStateList = [];
            if (options.defaults)
                object.expire = 0;
            if (message.freeRoomStateList && message.freeRoomStateList.length) {
                object.freeRoomStateList = [];
                for (var j = 0; j < message.freeRoomStateList.length; ++j)
                    object.freeRoomStateList[j] = $root.Room.FreeRoomState.toObject(message.freeRoomStateList[j], options);
            }
            if (message.expire != null && message.hasOwnProperty("expire"))
                object.expire = message.expire;
            return object;
        };

        /**
         * Converts this FreeBroadcast to JSON.
         * @function toJSON
         * @memberof Room.FreeBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FreeBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FreeBroadcast;
    })();

    Room.FreeSuccessBroadcast = (function() {

        /**
         * Properties of a FreeSuccessBroadcast.
         * @memberof Room
         * @interface IFreeSuccessBroadcast
         */

        /**
         * Constructs a new FreeSuccessBroadcast.
         * @memberof Room
         * @classdesc Represents a FreeSuccessBroadcast.
         * @implements IFreeSuccessBroadcast
         * @constructor
         * @param {Room.IFreeSuccessBroadcast=} [properties] Properties to set
         */
        function FreeSuccessBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new FreeSuccessBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {Room.IFreeSuccessBroadcast=} [properties] Properties to set
         * @returns {Room.FreeSuccessBroadcast} FreeSuccessBroadcast instance
         */
        FreeSuccessBroadcast.create = function create(properties) {
            return new FreeSuccessBroadcast(properties);
        };

        /**
         * Encodes the specified FreeSuccessBroadcast message. Does not implicitly {@link Room.FreeSuccessBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {Room.IFreeSuccessBroadcast} message FreeSuccessBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeSuccessBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Encodes the specified FreeSuccessBroadcast message, length delimited. Does not implicitly {@link Room.FreeSuccessBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {Room.IFreeSuccessBroadcast} message FreeSuccessBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        FreeSuccessBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a FreeSuccessBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.FreeSuccessBroadcast} FreeSuccessBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeSuccessBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.FreeSuccessBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a FreeSuccessBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.FreeSuccessBroadcast} FreeSuccessBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        FreeSuccessBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a FreeSuccessBroadcast message.
         * @function verify
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        FreeSuccessBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a FreeSuccessBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.FreeSuccessBroadcast} FreeSuccessBroadcast
         */
        FreeSuccessBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.FreeSuccessBroadcast)
                return object;
            return new $root.Room.FreeSuccessBroadcast();
        };

        /**
         * Creates a plain object from a FreeSuccessBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.FreeSuccessBroadcast
         * @static
         * @param {Room.FreeSuccessBroadcast} message FreeSuccessBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        FreeSuccessBroadcast.toObject = function toObject() {
            return {};
        };

        /**
         * Converts this FreeSuccessBroadcast to JSON.
         * @function toJSON
         * @memberof Room.FreeSuccessBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        FreeSuccessBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return FreeSuccessBroadcast;
    })();

    Room.KickPlayerBroadcast = (function() {

        /**
         * Properties of a KickPlayerBroadcast.
         * @memberof Room
         * @interface IKickPlayerBroadcast
         * @property {number|null} [playerId] KickPlayerBroadcast playerId
         */

        /**
         * Constructs a new KickPlayerBroadcast.
         * @memberof Room
         * @classdesc Represents a KickPlayerBroadcast.
         * @implements IKickPlayerBroadcast
         * @constructor
         * @param {Room.IKickPlayerBroadcast=} [properties] Properties to set
         */
        function KickPlayerBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * KickPlayerBroadcast playerId.
         * @member {number} playerId
         * @memberof Room.KickPlayerBroadcast
         * @instance
         */
        KickPlayerBroadcast.prototype.playerId = 0;

        /**
         * Creates a new KickPlayerBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {Room.IKickPlayerBroadcast=} [properties] Properties to set
         * @returns {Room.KickPlayerBroadcast} KickPlayerBroadcast instance
         */
        KickPlayerBroadcast.create = function create(properties) {
            return new KickPlayerBroadcast(properties);
        };

        /**
         * Encodes the specified KickPlayerBroadcast message. Does not implicitly {@link Room.KickPlayerBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {Room.IKickPlayerBroadcast} message KickPlayerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KickPlayerBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            return writer;
        };

        /**
         * Encodes the specified KickPlayerBroadcast message, length delimited. Does not implicitly {@link Room.KickPlayerBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {Room.IKickPlayerBroadcast} message KickPlayerBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        KickPlayerBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a KickPlayerBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.KickPlayerBroadcast} KickPlayerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KickPlayerBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.KickPlayerBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a KickPlayerBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.KickPlayerBroadcast} KickPlayerBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        KickPlayerBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a KickPlayerBroadcast message.
         * @function verify
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        KickPlayerBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            return null;
        };

        /**
         * Creates a KickPlayerBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.KickPlayerBroadcast} KickPlayerBroadcast
         */
        KickPlayerBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.KickPlayerBroadcast)
                return object;
            var message = new $root.Room.KickPlayerBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            return message;
        };

        /**
         * Creates a plain object from a KickPlayerBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.KickPlayerBroadcast
         * @static
         * @param {Room.KickPlayerBroadcast} message KickPlayerBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        KickPlayerBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerId = 0;
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            return object;
        };

        /**
         * Converts this KickPlayerBroadcast to JSON.
         * @function toJSON
         * @memberof Room.KickPlayerBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        KickPlayerBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return KickPlayerBroadcast;
    })();

    Room.LeaveBroadcast = (function() {

        /**
         * Properties of a LeaveBroadcast.
         * @memberof Room
         * @interface ILeaveBroadcast
         * @property {number} playerId LeaveBroadcast playerId
         * @property {number|null} [reason] LeaveBroadcast reason
         */

        /**
         * Constructs a new LeaveBroadcast.
         * @memberof Room
         * @classdesc Represents a LeaveBroadcast.
         * @implements ILeaveBroadcast
         * @constructor
         * @param {Room.ILeaveBroadcast=} [properties] Properties to set
         */
        function LeaveBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * LeaveBroadcast playerId.
         * @member {number} playerId
         * @memberof Room.LeaveBroadcast
         * @instance
         */
        LeaveBroadcast.prototype.playerId = 0;

        /**
         * LeaveBroadcast reason.
         * @member {number} reason
         * @memberof Room.LeaveBroadcast
         * @instance
         */
        LeaveBroadcast.prototype.reason = 0;

        /**
         * Creates a new LeaveBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {Room.ILeaveBroadcast=} [properties] Properties to set
         * @returns {Room.LeaveBroadcast} LeaveBroadcast instance
         */
        LeaveBroadcast.create = function create(properties) {
            return new LeaveBroadcast(properties);
        };

        /**
         * Encodes the specified LeaveBroadcast message. Does not implicitly {@link Room.LeaveBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {Room.ILeaveBroadcast} message LeaveBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.reason != null && message.hasOwnProperty("reason"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.reason);
            return writer;
        };

        /**
         * Encodes the specified LeaveBroadcast message, length delimited. Does not implicitly {@link Room.LeaveBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {Room.ILeaveBroadcast} message LeaveBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        LeaveBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a LeaveBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.LeaveBroadcast} LeaveBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.LeaveBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.reason = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            if (!message.hasOwnProperty("playerId"))
                throw $util.ProtocolError("missing required 'playerId'", { instance: message });
            return message;
        };

        /**
         * Decodes a LeaveBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.LeaveBroadcast} LeaveBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        LeaveBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a LeaveBroadcast message.
         * @function verify
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        LeaveBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (!$util.isInteger(message.playerId))
                return "playerId: integer expected";
            if (message.reason != null && message.hasOwnProperty("reason"))
                if (!$util.isInteger(message.reason))
                    return "reason: integer expected";
            return null;
        };

        /**
         * Creates a LeaveBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.LeaveBroadcast} LeaveBroadcast
         */
        LeaveBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.LeaveBroadcast)
                return object;
            var message = new $root.Room.LeaveBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.reason != null)
                message.reason = object.reason | 0;
            return message;
        };

        /**
         * Creates a plain object from a LeaveBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.LeaveBroadcast
         * @static
         * @param {Room.LeaveBroadcast} message LeaveBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        LeaveBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.reason = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.reason != null && message.hasOwnProperty("reason"))
                object.reason = message.reason;
            return object;
        };

        /**
         * Converts this LeaveBroadcast to JSON.
         * @function toJSON
         * @memberof Room.LeaveBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        LeaveBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return LeaveBroadcast;
    })();

    Room.ChatMsgBroadcast = (function() {

        /**
         * Properties of a ChatMsgBroadcast.
         * @memberof Room
         * @interface IChatMsgBroadcast
         * @property {number|null} [playerId] ChatMsgBroadcast playerId
         * @property {Room.IChatMsg|null} [chatMsg] ChatMsgBroadcast chatMsg
         */

        /**
         * Constructs a new ChatMsgBroadcast.
         * @memberof Room
         * @classdesc Represents a ChatMsgBroadcast.
         * @implements IChatMsgBroadcast
         * @constructor
         * @param {Room.IChatMsgBroadcast=} [properties] Properties to set
         */
        function ChatMsgBroadcast(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ChatMsgBroadcast playerId.
         * @member {number} playerId
         * @memberof Room.ChatMsgBroadcast
         * @instance
         */
        ChatMsgBroadcast.prototype.playerId = 0;

        /**
         * ChatMsgBroadcast chatMsg.
         * @member {Room.IChatMsg|null|undefined} chatMsg
         * @memberof Room.ChatMsgBroadcast
         * @instance
         */
        ChatMsgBroadcast.prototype.chatMsg = null;

        /**
         * Creates a new ChatMsgBroadcast instance using the specified properties.
         * @function create
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {Room.IChatMsgBroadcast=} [properties] Properties to set
         * @returns {Room.ChatMsgBroadcast} ChatMsgBroadcast instance
         */
        ChatMsgBroadcast.create = function create(properties) {
            return new ChatMsgBroadcast(properties);
        };

        /**
         * Encodes the specified ChatMsgBroadcast message. Does not implicitly {@link Room.ChatMsgBroadcast.verify|verify} messages.
         * @function encode
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {Room.IChatMsgBroadcast} message ChatMsgBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsgBroadcast.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.chatMsg != null && message.hasOwnProperty("chatMsg"))
                $root.Room.ChatMsg.encode(message.chatMsg, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified ChatMsgBroadcast message, length delimited. Does not implicitly {@link Room.ChatMsgBroadcast.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {Room.IChatMsgBroadcast} message ChatMsgBroadcast message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ChatMsgBroadcast.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a ChatMsgBroadcast message from the specified reader or buffer.
         * @function decode
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.ChatMsgBroadcast} ChatMsgBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsgBroadcast.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.ChatMsgBroadcast();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.chatMsg = $root.Room.ChatMsg.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a ChatMsgBroadcast message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.ChatMsgBroadcast} ChatMsgBroadcast
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ChatMsgBroadcast.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a ChatMsgBroadcast message.
         * @function verify
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        ChatMsgBroadcast.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.chatMsg != null && message.hasOwnProperty("chatMsg")) {
                var error = $root.Room.ChatMsg.verify(message.chatMsg);
                if (error)
                    return "chatMsg." + error;
            }
            return null;
        };

        /**
         * Creates a ChatMsgBroadcast message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.ChatMsgBroadcast} ChatMsgBroadcast
         */
        ChatMsgBroadcast.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.ChatMsgBroadcast)
                return object;
            var message = new $root.Room.ChatMsgBroadcast();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.chatMsg != null) {
                if (typeof object.chatMsg !== "object")
                    throw TypeError(".Room.ChatMsgBroadcast.chatMsg: object expected");
                message.chatMsg = $root.Room.ChatMsg.fromObject(object.chatMsg);
            }
            return message;
        };

        /**
         * Creates a plain object from a ChatMsgBroadcast message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.ChatMsgBroadcast
         * @static
         * @param {Room.ChatMsgBroadcast} message ChatMsgBroadcast
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ChatMsgBroadcast.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.chatMsg = null;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.chatMsg != null && message.hasOwnProperty("chatMsg"))
                object.chatMsg = $root.Room.ChatMsg.toObject(message.chatMsg, options);
            return object;
        };

        /**
         * Converts this ChatMsgBroadcast to JSON.
         * @function toJSON
         * @memberof Room.ChatMsgBroadcast
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        ChatMsgBroadcast.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ChatMsgBroadcast;
    })();

    Room.CancelReadyNotify = (function() {

        /**
         * Properties of a CancelReadyNotify.
         * @memberof Room
         * @interface ICancelReadyNotify
         * @property {number|null} [playerid] CancelReadyNotify playerid
         */

        /**
         * Constructs a new CancelReadyNotify.
         * @memberof Room
         * @classdesc Represents a CancelReadyNotify.
         * @implements ICancelReadyNotify
         * @constructor
         * @param {Room.ICancelReadyNotify=} [properties] Properties to set
         */
        function CancelReadyNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * CancelReadyNotify playerid.
         * @member {number} playerid
         * @memberof Room.CancelReadyNotify
         * @instance
         */
        CancelReadyNotify.prototype.playerid = 0;

        /**
         * Creates a new CancelReadyNotify instance using the specified properties.
         * @function create
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {Room.ICancelReadyNotify=} [properties] Properties to set
         * @returns {Room.CancelReadyNotify} CancelReadyNotify instance
         */
        CancelReadyNotify.create = function create(properties) {
            return new CancelReadyNotify(properties);
        };

        /**
         * Encodes the specified CancelReadyNotify message. Does not implicitly {@link Room.CancelReadyNotify.verify|verify} messages.
         * @function encode
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {Room.ICancelReadyNotify} message CancelReadyNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelReadyNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerid != null && message.hasOwnProperty("playerid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerid);
            return writer;
        };

        /**
         * Encodes the specified CancelReadyNotify message, length delimited. Does not implicitly {@link Room.CancelReadyNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {Room.ICancelReadyNotify} message CancelReadyNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        CancelReadyNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a CancelReadyNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.CancelReadyNotify} CancelReadyNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelReadyNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.CancelReadyNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a CancelReadyNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.CancelReadyNotify} CancelReadyNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        CancelReadyNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a CancelReadyNotify message.
         * @function verify
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        CancelReadyNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerid != null && message.hasOwnProperty("playerid"))
                if (!$util.isInteger(message.playerid))
                    return "playerid: integer expected";
            return null;
        };

        /**
         * Creates a CancelReadyNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.CancelReadyNotify} CancelReadyNotify
         */
        CancelReadyNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.CancelReadyNotify)
                return object;
            var message = new $root.Room.CancelReadyNotify();
            if (object.playerid != null)
                message.playerid = object.playerid | 0;
            return message;
        };

        /**
         * Creates a plain object from a CancelReadyNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.CancelReadyNotify
         * @static
         * @param {Room.CancelReadyNotify} message CancelReadyNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        CancelReadyNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults)
                object.playerid = 0;
            if (message.playerid != null && message.hasOwnProperty("playerid"))
                object.playerid = message.playerid;
            return object;
        };

        /**
         * Converts this CancelReadyNotify to JSON.
         * @function toJSON
         * @memberof Room.CancelReadyNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        CancelReadyNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return CancelReadyNotify;
    })();

    Room.OwnerChangeNotify = (function() {

        /**
         * Properties of an OwnerChangeNotify.
         * @memberof Room
         * @interface IOwnerChangeNotify
         * @property {number|null} [oldOwnerid] OwnerChangeNotify oldOwnerid
         * @property {number|null} [newOwnerid] OwnerChangeNotify newOwnerid
         */

        /**
         * Constructs a new OwnerChangeNotify.
         * @memberof Room
         * @classdesc Represents an OwnerChangeNotify.
         * @implements IOwnerChangeNotify
         * @constructor
         * @param {Room.IOwnerChangeNotify=} [properties] Properties to set
         */
        function OwnerChangeNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * OwnerChangeNotify oldOwnerid.
         * @member {number} oldOwnerid
         * @memberof Room.OwnerChangeNotify
         * @instance
         */
        OwnerChangeNotify.prototype.oldOwnerid = 0;

        /**
         * OwnerChangeNotify newOwnerid.
         * @member {number} newOwnerid
         * @memberof Room.OwnerChangeNotify
         * @instance
         */
        OwnerChangeNotify.prototype.newOwnerid = 0;

        /**
         * Creates a new OwnerChangeNotify instance using the specified properties.
         * @function create
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {Room.IOwnerChangeNotify=} [properties] Properties to set
         * @returns {Room.OwnerChangeNotify} OwnerChangeNotify instance
         */
        OwnerChangeNotify.create = function create(properties) {
            return new OwnerChangeNotify(properties);
        };

        /**
         * Encodes the specified OwnerChangeNotify message. Does not implicitly {@link Room.OwnerChangeNotify.verify|verify} messages.
         * @function encode
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {Room.IOwnerChangeNotify} message OwnerChangeNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OwnerChangeNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.oldOwnerid != null && message.hasOwnProperty("oldOwnerid"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.oldOwnerid);
            if (message.newOwnerid != null && message.hasOwnProperty("newOwnerid"))
                writer.uint32(/* id 2, wireType 0 =*/16).int32(message.newOwnerid);
            return writer;
        };

        /**
         * Encodes the specified OwnerChangeNotify message, length delimited. Does not implicitly {@link Room.OwnerChangeNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {Room.IOwnerChangeNotify} message OwnerChangeNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        OwnerChangeNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes an OwnerChangeNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.OwnerChangeNotify} OwnerChangeNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OwnerChangeNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.OwnerChangeNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.oldOwnerid = reader.int32();
                    break;
                case 2:
                    message.newOwnerid = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes an OwnerChangeNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.OwnerChangeNotify} OwnerChangeNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        OwnerChangeNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies an OwnerChangeNotify message.
         * @function verify
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        OwnerChangeNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.oldOwnerid != null && message.hasOwnProperty("oldOwnerid"))
                if (!$util.isInteger(message.oldOwnerid))
                    return "oldOwnerid: integer expected";
            if (message.newOwnerid != null && message.hasOwnProperty("newOwnerid"))
                if (!$util.isInteger(message.newOwnerid))
                    return "newOwnerid: integer expected";
            return null;
        };

        /**
         * Creates an OwnerChangeNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.OwnerChangeNotify} OwnerChangeNotify
         */
        OwnerChangeNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.OwnerChangeNotify)
                return object;
            var message = new $root.Room.OwnerChangeNotify();
            if (object.oldOwnerid != null)
                message.oldOwnerid = object.oldOwnerid | 0;
            if (object.newOwnerid != null)
                message.newOwnerid = object.newOwnerid | 0;
            return message;
        };

        /**
         * Creates a plain object from an OwnerChangeNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.OwnerChangeNotify
         * @static
         * @param {Room.OwnerChangeNotify} message OwnerChangeNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        OwnerChangeNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.oldOwnerid = 0;
                object.newOwnerid = 0;
            }
            if (message.oldOwnerid != null && message.hasOwnProperty("oldOwnerid"))
                object.oldOwnerid = message.oldOwnerid;
            if (message.newOwnerid != null && message.hasOwnProperty("newOwnerid"))
                object.newOwnerid = message.newOwnerid;
            return object;
        };

        /**
         * Converts this OwnerChangeNotify to JSON.
         * @function toJSON
         * @memberof Room.OwnerChangeNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        OwnerChangeNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return OwnerChangeNotify;
    })();

    Room.UserCoinBalanceNotify = (function() {

        /**
         * Properties of a UserCoinBalanceNotify.
         * @memberof Room
         * @interface IUserCoinBalanceNotify
         * @property {number|null} [playerId] UserCoinBalanceNotify playerId
         * @property {number|null} [coinBalance] UserCoinBalanceNotify coinBalance
         */

        /**
         * Constructs a new UserCoinBalanceNotify.
         * @memberof Room
         * @classdesc Represents a UserCoinBalanceNotify.
         * @implements IUserCoinBalanceNotify
         * @constructor
         * @param {Room.IUserCoinBalanceNotify=} [properties] Properties to set
         */
        function UserCoinBalanceNotify(properties) {
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UserCoinBalanceNotify playerId.
         * @member {number} playerId
         * @memberof Room.UserCoinBalanceNotify
         * @instance
         */
        UserCoinBalanceNotify.prototype.playerId = 0;

        /**
         * UserCoinBalanceNotify coinBalance.
         * @member {number} coinBalance
         * @memberof Room.UserCoinBalanceNotify
         * @instance
         */
        UserCoinBalanceNotify.prototype.coinBalance = 0;

        /**
         * Creates a new UserCoinBalanceNotify instance using the specified properties.
         * @function create
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {Room.IUserCoinBalanceNotify=} [properties] Properties to set
         * @returns {Room.UserCoinBalanceNotify} UserCoinBalanceNotify instance
         */
        UserCoinBalanceNotify.create = function create(properties) {
            return new UserCoinBalanceNotify(properties);
        };

        /**
         * Encodes the specified UserCoinBalanceNotify message. Does not implicitly {@link Room.UserCoinBalanceNotify.verify|verify} messages.
         * @function encode
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {Room.IUserCoinBalanceNotify} message UserCoinBalanceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserCoinBalanceNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                writer.uint32(/* id 2, wireType 1 =*/17).double(message.coinBalance);
            return writer;
        };

        /**
         * Encodes the specified UserCoinBalanceNotify message, length delimited. Does not implicitly {@link Room.UserCoinBalanceNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {Room.IUserCoinBalanceNotify} message UserCoinBalanceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UserCoinBalanceNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a UserCoinBalanceNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.UserCoinBalanceNotify} UserCoinBalanceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserCoinBalanceNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.UserCoinBalanceNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.playerId = reader.int32();
                    break;
                case 2:
                    message.coinBalance = reader.double();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a UserCoinBalanceNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.UserCoinBalanceNotify} UserCoinBalanceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UserCoinBalanceNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a UserCoinBalanceNotify message.
         * @function verify
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        UserCoinBalanceNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                if (!$util.isInteger(message.playerId))
                    return "playerId: integer expected";
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                if (typeof message.coinBalance !== "number")
                    return "coinBalance: number expected";
            return null;
        };

        /**
         * Creates a UserCoinBalanceNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.UserCoinBalanceNotify} UserCoinBalanceNotify
         */
        UserCoinBalanceNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.UserCoinBalanceNotify)
                return object;
            var message = new $root.Room.UserCoinBalanceNotify();
            if (object.playerId != null)
                message.playerId = object.playerId | 0;
            if (object.coinBalance != null)
                message.coinBalance = Number(object.coinBalance);
            return message;
        };

        /**
         * Creates a plain object from a UserCoinBalanceNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.UserCoinBalanceNotify
         * @static
         * @param {Room.UserCoinBalanceNotify} message UserCoinBalanceNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UserCoinBalanceNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.defaults) {
                object.playerId = 0;
                object.coinBalance = 0;
            }
            if (message.playerId != null && message.hasOwnProperty("playerId"))
                object.playerId = message.playerId;
            if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
            return object;
        };

        /**
         * Converts this UserCoinBalanceNotify to JSON.
         * @function toJSON
         * @memberof Room.UserCoinBalanceNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        UserCoinBalanceNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UserCoinBalanceNotify;
    })();

    Room.BatchCoinBalanceNotify = (function() {

        /**
         * Properties of a BatchCoinBalanceNotify.
         * @memberof Room
         * @interface IBatchCoinBalanceNotify
         * @property {Array.<Room.BatchCoinBalanceNotify.IPlayer>|null} [players] BatchCoinBalanceNotify players
         */

        /**
         * Constructs a new BatchCoinBalanceNotify.
         * @memberof Room
         * @classdesc Represents a BatchCoinBalanceNotify.
         * @implements IBatchCoinBalanceNotify
         * @constructor
         * @param {Room.IBatchCoinBalanceNotify=} [properties] Properties to set
         */
        function BatchCoinBalanceNotify(properties) {
            this.players = [];
            if (properties)
                for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * BatchCoinBalanceNotify players.
         * @member {Array.<Room.BatchCoinBalanceNotify.IPlayer>} players
         * @memberof Room.BatchCoinBalanceNotify
         * @instance
         */
        BatchCoinBalanceNotify.prototype.players = $util.emptyArray;

        /**
         * Creates a new BatchCoinBalanceNotify instance using the specified properties.
         * @function create
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {Room.IBatchCoinBalanceNotify=} [properties] Properties to set
         * @returns {Room.BatchCoinBalanceNotify} BatchCoinBalanceNotify instance
         */
        BatchCoinBalanceNotify.create = function create(properties) {
            return new BatchCoinBalanceNotify(properties);
        };

        /**
         * Encodes the specified BatchCoinBalanceNotify message. Does not implicitly {@link Room.BatchCoinBalanceNotify.verify|verify} messages.
         * @function encode
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {Room.IBatchCoinBalanceNotify} message BatchCoinBalanceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BatchCoinBalanceNotify.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.players != null && message.players.length)
                for (var i = 0; i < message.players.length; ++i)
                    $root.Room.BatchCoinBalanceNotify.Player.encode(message.players[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Encodes the specified BatchCoinBalanceNotify message, length delimited. Does not implicitly {@link Room.BatchCoinBalanceNotify.verify|verify} messages.
         * @function encodeDelimited
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {Room.IBatchCoinBalanceNotify} message BatchCoinBalanceNotify message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        BatchCoinBalanceNotify.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a BatchCoinBalanceNotify message from the specified reader or buffer.
         * @function decode
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {Room.BatchCoinBalanceNotify} BatchCoinBalanceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BatchCoinBalanceNotify.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.BatchCoinBalanceNotify();
            while (reader.pos < end) {
                var tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.players && message.players.length))
                        message.players = [];
                    message.players.push($root.Room.BatchCoinBalanceNotify.Player.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Decodes a BatchCoinBalanceNotify message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {Room.BatchCoinBalanceNotify} BatchCoinBalanceNotify
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        BatchCoinBalanceNotify.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        /**
         * Verifies a BatchCoinBalanceNotify message.
         * @function verify
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {string|null} `null` if valid, otherwise the reason why it is not
         */
        BatchCoinBalanceNotify.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.players != null && message.hasOwnProperty("players")) {
                if (!Array.isArray(message.players))
                    return "players: array expected";
                for (var i = 0; i < message.players.length; ++i) {
                    var error = $root.Room.BatchCoinBalanceNotify.Player.verify(message.players[i]);
                    if (error)
                        return "players." + error;
                }
            }
            return null;
        };

        /**
         * Creates a BatchCoinBalanceNotify message from a plain object. Also converts values to their respective internal types.
         * @function fromObject
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {Object.<string,*>} object Plain object
         * @returns {Room.BatchCoinBalanceNotify} BatchCoinBalanceNotify
         */
        BatchCoinBalanceNotify.fromObject = function fromObject(object) {
            if (object instanceof $root.Room.BatchCoinBalanceNotify)
                return object;
            var message = new $root.Room.BatchCoinBalanceNotify();
            if (object.players) {
                if (!Array.isArray(object.players))
                    throw TypeError(".Room.BatchCoinBalanceNotify.players: array expected");
                message.players = [];
                for (var i = 0; i < object.players.length; ++i) {
                    if (typeof object.players[i] !== "object")
                        throw TypeError(".Room.BatchCoinBalanceNotify.players: object expected");
                    message.players[i] = $root.Room.BatchCoinBalanceNotify.Player.fromObject(object.players[i]);
                }
            }
            return message;
        };

        /**
         * Creates a plain object from a BatchCoinBalanceNotify message. Also converts values to other types if specified.
         * @function toObject
         * @memberof Room.BatchCoinBalanceNotify
         * @static
         * @param {Room.BatchCoinBalanceNotify} message BatchCoinBalanceNotify
         * @param {$protobuf.IConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        BatchCoinBalanceNotify.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            var object = {};
            if (options.arrays || options.defaults)
                object.players = [];
            if (message.players && message.players.length) {
                object.players = [];
                for (var j = 0; j < message.players.length; ++j)
                    object.players[j] = $root.Room.BatchCoinBalanceNotify.Player.toObject(message.players[j], options);
            }
            return object;
        };

        /**
         * Converts this BatchCoinBalanceNotify to JSON.
         * @function toJSON
         * @memberof Room.BatchCoinBalanceNotify
         * @instance
         * @returns {Object.<string,*>} JSON object
         */
        BatchCoinBalanceNotify.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        BatchCoinBalanceNotify.Player = (function() {

            /**
             * Properties of a Player.
             * @memberof Room.BatchCoinBalanceNotify
             * @interface IPlayer
             * @property {number|null} [playerId] Player playerId
             * @property {number|null} [coinBalance] Player coinBalance
             */

            /**
             * Constructs a new Player.
             * @memberof Room.BatchCoinBalanceNotify
             * @classdesc Represents a Player.
             * @implements IPlayer
             * @constructor
             * @param {Room.BatchCoinBalanceNotify.IPlayer=} [properties] Properties to set
             */
            function Player(properties) {
                if (properties)
                    for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                        if (properties[keys[i]] != null)
                            this[keys[i]] = properties[keys[i]];
            }

            /**
             * Player playerId.
             * @member {number} playerId
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @instance
             */
            Player.prototype.playerId = 0;

            /**
             * Player coinBalance.
             * @member {number} coinBalance
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @instance
             */
            Player.prototype.coinBalance = 0;

            /**
             * Creates a new Player instance using the specified properties.
             * @function create
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {Room.BatchCoinBalanceNotify.IPlayer=} [properties] Properties to set
             * @returns {Room.BatchCoinBalanceNotify.Player} Player instance
             */
            Player.create = function create(properties) {
                return new Player(properties);
            };

            /**
             * Encodes the specified Player message. Does not implicitly {@link Room.BatchCoinBalanceNotify.Player.verify|verify} messages.
             * @function encode
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {Room.BatchCoinBalanceNotify.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encode = function encode(message, writer) {
                if (!writer)
                    writer = $Writer.create();
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    writer.uint32(/* id 1, wireType 0 =*/8).int32(message.playerId);
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    writer.uint32(/* id 2, wireType 1 =*/17).double(message.coinBalance);
                return writer;
            };

            /**
             * Encodes the specified Player message, length delimited. Does not implicitly {@link Room.BatchCoinBalanceNotify.Player.verify|verify} messages.
             * @function encodeDelimited
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {Room.BatchCoinBalanceNotify.IPlayer} message Player message or plain object to encode
             * @param {$protobuf.Writer} [writer] Writer to encode to
             * @returns {$protobuf.Writer} Writer
             */
            Player.encodeDelimited = function encodeDelimited(message, writer) {
                return this.encode(message, writer).ldelim();
            };

            /**
             * Decodes a Player message from the specified reader or buffer.
             * @function decode
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @param {number} [length] Message length if known beforehand
             * @returns {Room.BatchCoinBalanceNotify.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decode = function decode(reader, length) {
                if (!(reader instanceof $Reader))
                    reader = $Reader.create(reader);
                var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Room.BatchCoinBalanceNotify.Player();
                while (reader.pos < end) {
                    var tag = reader.uint32();
                    switch (tag >>> 3) {
                    case 1:
                        message.playerId = reader.int32();
                        break;
                    case 2:
                        message.coinBalance = reader.double();
                        break;
                    default:
                        reader.skipType(tag & 7);
                        break;
                    }
                }
                return message;
            };

            /**
             * Decodes a Player message from the specified reader or buffer, length delimited.
             * @function decodeDelimited
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
             * @returns {Room.BatchCoinBalanceNotify.Player} Player
             * @throws {Error} If the payload is not a reader or valid buffer
             * @throws {$protobuf.util.ProtocolError} If required fields are missing
             */
            Player.decodeDelimited = function decodeDelimited(reader) {
                if (!(reader instanceof $Reader))
                    reader = new $Reader(reader);
                return this.decode(reader, reader.uint32());
            };

            /**
             * Verifies a Player message.
             * @function verify
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {Object.<string,*>} message Plain object to verify
             * @returns {string|null} `null` if valid, otherwise the reason why it is not
             */
            Player.verify = function verify(message) {
                if (typeof message !== "object" || message === null)
                    return "object expected";
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    if (!$util.isInteger(message.playerId))
                        return "playerId: integer expected";
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    if (typeof message.coinBalance !== "number")
                        return "coinBalance: number expected";
                return null;
            };

            /**
             * Creates a Player message from a plain object. Also converts values to their respective internal types.
             * @function fromObject
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {Object.<string,*>} object Plain object
             * @returns {Room.BatchCoinBalanceNotify.Player} Player
             */
            Player.fromObject = function fromObject(object) {
                if (object instanceof $root.Room.BatchCoinBalanceNotify.Player)
                    return object;
                var message = new $root.Room.BatchCoinBalanceNotify.Player();
                if (object.playerId != null)
                    message.playerId = object.playerId | 0;
                if (object.coinBalance != null)
                    message.coinBalance = Number(object.coinBalance);
                return message;
            };

            /**
             * Creates a plain object from a Player message. Also converts values to other types if specified.
             * @function toObject
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @static
             * @param {Room.BatchCoinBalanceNotify.Player} message Player
             * @param {$protobuf.IConversionOptions} [options] Conversion options
             * @returns {Object.<string,*>} Plain object
             */
            Player.toObject = function toObject(message, options) {
                if (!options)
                    options = {};
                var object = {};
                if (options.defaults) {
                    object.playerId = 0;
                    object.coinBalance = 0;
                }
                if (message.playerId != null && message.hasOwnProperty("playerId"))
                    object.playerId = message.playerId;
                if (message.coinBalance != null && message.hasOwnProperty("coinBalance"))
                    object.coinBalance = options.json && !isFinite(message.coinBalance) ? String(message.coinBalance) : message.coinBalance;
                return object;
            };

            /**
             * Converts this Player to JSON.
             * @function toJSON
             * @memberof Room.BatchCoinBalanceNotify.Player
             * @instance
             * @returns {Object.<string,*>} JSON object
             */
            Player.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            return Player;
        })();

        return BatchCoinBalanceNotify;
    })();

    return Room;
})();

module.exports = $root;
